import React, { Component } from "react";
import { BsyUtils } from "../../../utils/Utils";
import BsyDataTable from "../../BsyDataTable";
import BsyPivotTable from "../BsyPivotTable";
import BsyGantt from "../BsyGantt";
import BsyDashBarChart from "../BsyDashBarChart";
import BsyDashLineChart from "../BsyDashLineChart";
import BsyDashPieChart from "../BsyDashPieChart";
import BsyDashAreaChart from "../BsyDashAreaChart";
import BsyDashRadarChart from "../BsyDashRadarChart";
import BsyDashMultiAxesChart from "../BsyDashMultiAxesChart";
import BsyDashMapChart from "../BsyDashMapChart";
import BsyDashFunnelChart from "../BsyDashFunnelChart";
import BsyDashGaugeChart from "../BsyDashGaugeChart";
import BsyDashMap from "../BsyDashMap";
import BsyDashCard from "../BsyDashCard";
import BsyDashWebPage from "../BsyDashWebPage";

import BsySlidePane from "../../BsySlidePane";
import BsySelect from "../../BsySelect";
import BsyDashContainer from "../../dash/BsyDashContainer"; // 编辑-数据表菜单栏

import BsyDashRiliChart from "../BsyDashRiliChart";
import BsyDashDescription from "../BsyDashDescription";
import BsyDashImage from "../BsyDashImage";
import BsyDashImageMore from "../BsyDashImageMore";
import BsyDashRealTime from "../BsyDashRealTime";
import BysDashEmbeddedIframe from "../BysDashEmbeddedIframe";

import BsyMetricTable from "../BsyMetricTable";
import BsyDashBaseLayoutContainer from "../BsyDashBaseLayoutContainer";

import "./index.css";
import BsyAlertMenu from "../../BsyAlertMenu";
import { BsyFilterText } from "../../filterField/BsyFilterText";
import { BsyFilterComboCheck } from "../../filterField/BsyFilterComboCheck";
import { BsyFilterTextArea } from "../../filterField/BsyFilterTextArea";
import { BsyFilterFile } from "../../filterField/BsyFilterFile";
import { BsyFilterUser } from "../../filterField/BsyFilterUser";
import { BsyFilterUserGroup } from "../../filterField/BsyFilterUserGroup";
import { BsyFilterAddress } from "../../filterField/BsyFilterAddress";
import { BsyFilterNumber } from "../../filterField/BsyFilterNumber";
import { BsyFilterFlowState } from "../../filterField/BsyFilterFlowState";
import { BsyFilterDeptGroup } from "../../filterField/BsyFilterDeptGroup";
import { BsyFilterDept } from "../../filterField/BsyFilterDept";
import { BsyFilterDate } from "../../filterField/BsyFilterDate";
import { BsyFilteQuick } from "../../filterField/BsyFilteQuick";

import { BsyFilterBtn } from "../../filterField/BsyFilterBtn";
import BsyAlert from "../../BsyAlert";
import { BsyFilterFlowDecision } from "../../filterField/BsyFilterFlowDecision";
import { BsyFilterFlowAssistProstatus } from "../../filterField/BsyFilterFlowAssistProstatus";
import { BsyFilterFlowAssistFlowid } from "../../filterField/BsyFilterFlowAssistFlowid";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsyFormPane from "../../BsyFormPane";
import BsySLoading from "../../BsySLoading";
import { WindowPropsContext, windowProp } from "../component_context.js";

import _ from "lodash";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { BsyConfig } from "../../../global/BsyConfig.js";
import { createTooltip } from "../../../utils/createTooltip.jsx";

class BsyDashComponent extends Component {
  static contextType = WindowPropsContext;
  static defaultProps = {
    popupFormPath: [],
    lazyLoading: true,
    autoLoad: false,
    is_dock_form: false,
    mountAutoLoad: true,
    operates: [],
    env: "", // dashboard 工作台,禁用请求接口的错误提示
    // rel: "and",
  };
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      widget: props.widget,
      is_dock_form: props.is_dock_form,
      operates:
        props.operates.length === 0
          ? this.getOperates(props.widget)
          : props.operates,
      operateTitle: "", //二级菜单的时候，菜单标题
      floatMenus: [], //出现多的时候
      visible: false, // 标记懒加载是否触发
      isConfigError: false,
      configErrorTip: "",
      allComponentDash: props.allComponentDash,
      globFilter: props.globFilter,
      hasDelete: props.hasDelete || false,
    };

    this.element = React.createRef();
    this.etlBtn = React.createRef();

    this.refTitle = React.createRef();
    this.refOptBtn = React.createRef();
    this.refHeader = React.createRef();
    this.blockContent = React.createRef();

    this.popupFormPath = [...props.popupFormPath];
    this.isload = false;
    this.isDashFull = props.isDashFull;
    this.filter = null;

    this.filterMap = null;
    this.linkFilter = null;
    // this.rel = this.props.rel || "and";
    this.menuId = null;
  }

  checkInPage = () => {


    if (!this.props.lazyLoading) {
      return;
    }

    if (this.state.visible) {
      return;
    }

    let isVisible = !this.element.current
      ? false
      : BsyUtils.checkInPage(this.element.current);

    // if (this.state.widget.title === "采购订单签订数") {
    //   debugger
    // }
    // console.log("checkInPage " + isVisible, this.state.widget.title);
    if (isVisible === true) {
      this.componentContext &&
        this.componentContext.loadWidget &&
        this.componentContext.loadWidget();

      this.rootScrollElement?.removeEventListener("scroll", this.checkInPage);
      this.scrollElement?.removeEventListener("scroll", this.checkInPage);
      this.rootScrollElement = null;
      this.scrollElement = null;
      this.setState({ visible: isVisible });
    }
  };

  componentWillUnmount() {
    this.hideTooltip();
    if (this.props.lazyLoading === true) {
      this.scrollElement?.removeEventListener("scroll", this.checkInPage);
      this.rootScrollElement?.removeEventListener("scroll", this.checkInPage);
    }
  }

  componentDidMount() {
    let that = this;
    if (this.props.getContext) {
      this.props.getContext(this);
    }

    if (this.props.lazyLoading === true) {
      setTimeout(() => {
        that.rootScrollElement = null; // BsyUtils.closestClass(this.element.current, "bsy-dash");

        if (that.state.widget.parentsId) {
          //容器内的滚动条
          that.scrollElement = BsyUtils.closestClass(this.element.current, "bsy-dash");
          if (that.scrollElement) {
            that.rootScrollElement = BsyUtils.closestClass(that.scrollElement.parentElement, "bsy-dash");
          }
        } else {
          that.rootScrollElement = BsyUtils.closestClass(this.element.current, "bsy-dash");
        }

        that.rootScrollElement?.addEventListener("scroll", this.checkInPage);
        that.scrollElement?.addEventListener("scroll", this.checkInPage);

        this.checkInPage();
      }, 200);
    }
    this.reMoreOperate();
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    let widget = {};
    if (!BsyUtils.compare(nextProps.widget, this.state.widget)) {
      widget = nextProps.widget && { ...nextProps.widget };
    }

    // if (nextProps.rel !== this.rel){
    //     this.rel = nextProps.rel;
    // }

    if (nextProps.isDashFull !== this.isDashFull)
      this.isDashFull = nextProps.isDashFull;

    if (!BsyUtils.isObjectEmpty(widget)) {
      this.setState({
        widget: widget,
        operates:
          nextProps.operates.length === 0
            ? [...this.getOperates(widget)]
            : [...nextProps.operates],
      });
    }
  }

  setFilter = (t, filterMap) => {
    this.filter = t;
    this.filterMap = filterMap;
    // this.rel = rel;
  };

  _getFilter = (t) => {
    let e = [],
      i = this.state;
    let _this = this;
    this.filterMap = {};
    BsyUtils.forEach(
      _this?.context?.getOverallSituationValue("filter"),
      function (a, n) {
        let widgetId = a;
        n.triggers &&
          n.method &&
          BsyUtils.forEach(n.triggers, function (a, s) {
            if (s === t) {
              let o = i.allComponentDash.entry.components[t].forms[0];
              let widget = i.allComponentDash.entry.components[t];
              return (
                BsyUtils.forEach(n.fields, function (t, i) {
                  if (i.form === o) {
                    let a = {
                      ...n,
                      ...{
                        entryId: i.form,
                        field: i.field,
                      },
                    };

                    if (widget && widget.background == 1) {
                      a.entryId = window.FX.STATIC.entryId;
                    }
                    if (i.subform) {
                      a = {
                        ...a,
                        ...{
                          subform: i.subform,
                          subField: i.subField,
                        },
                      };
                    } else {
                      a.subform = null;
                      a.subField = null;
                    }
                    e.push(a);

                    // i.subform ? ($.extend(a, {
                    //     subform: i.subform,
                    //     subField: i.subField
                    // }),
                    //     a.field = void 0) : (a.subform = void 0,
                    //         a.subField = void 0),
                    //     e.push(a);

                    _this.filterMap[widgetId] = a;
                    return !1;
                  }
                }),
                !1
              );
            }
          });
      }
    );
    return BsyUtils.getValidFilters({
      cond: e,
    }).cond;
  };

  setFilterMap = (filterMap) => {
    this.filterMap = filterMap;
  };
  setLinkFilter = (t) => {
    this.linkFilter = t;
  };

  doFilterRely = (t, rel, widgetFilter) => {
    if (this.componentContext)
      if (this.componentContext.doFilterRely)
        this.componentContext.doFilterRely(t, rel, widgetFilter);
  };
  setDefaultConfig = () => {
    if (this.componentContext)
      if (this.componentContext.setDefaultConfig)
        this.componentContext.setDefaultConfig();
  };
  clearConfig = () => {
    if (this.componentContext)
      if (this.componentContext.clearConfig)
        this.componentContext.clearConfig();
  };

  setFilterbak = (t) => {
    this.filterbak = t;
    if (this.componentContext) {
      if (this.componentContext.setFilterbak) {
        this.componentContext.setFilterbak(t);
      }
    }
    // this.componentContext && this.componentContext.setFilterbak = t
  };

  reMoreOperate = () => {
    const { operates, floatMenus } = this.state;
    if (operates.length === 0) return;
    if (
      this.element.current.getElementsByClassName("block-operate").length <= 0
    ) {
      return;
    }

    let operateBtns = this.element.current
      .getElementsByClassName("block-operate")[0]
      .getElementsByClassName("operate-btn");
    for (let i = 0; i < operateBtns.length; i++) {
      operateBtns[i].style.display = "block";
    }
    let floatMenus1 = floatMenus;
    if (
      this.refTitle.current.offsetWidth +
      this.refOptBtn.current.offsetWidth +
      10 >
      this.refHeader.current.offsetWidth
    ) {
      floatMenus1 = [];
      //出现重叠了
      if (this.refOptBtn.current.getElementsByClassName("operate-more").length)
        this.refOptBtn.current.getElementsByClassName(
          "operate-more"
        )[0].style.display = "block";

      for (let i = 0; i < operateBtns.length; i++) {
        operateBtns[i].style.display = "block";
        if (
          this.refTitle.current.offsetWidth +
          this.refOptBtn.current.offsetWidth +
          10 >
          this.refHeader.current.offsetWidth
        ) {
          operateBtns[i].style.display = "none";
          floatMenus1.push(operateBtns[i].getAttribute("role"));
        }
      }
    } else {
      if (this.refOptBtn.current.getElementsByClassName("operate-more").length)
        this.refOptBtn.current.getElementsByClassName(
          "operate-more"
        )[0].style.display = "none";
      // }
    }

    this.setState({
      floatMenus: floatMenus1,
    });
  };

  renderTitle = () => {
    const { widget } = this.state;
    let title = widget.title;
    if (widget.type === "metric_table") {
      if (
        widget.xFields.length === 0 &&
        widget.styles &&
        widget.styles.theme &&
        widget.styles.theme.cardName &&
        widget.styles.theme.cardName !== "preset_metric_1"
      ) {
        title = "";
      }
    }
    // console.log('---renderTitle---', widget.title, title, widget.styles);
    // widget.type === "metric_table" ? (widget.styles ? (widget.styles.theme ? (widget.styles.theme.cardName === "preset_metric_1" || widget.xFields.length > 0) ? widget.title : "" : widget.title) : widget.title) : widget.title
    return (
      <div className="block-title" title={widget.title} ref={this.refTitle}>
        {title}
      </div>
    );
  };

  sort = () => {
    if (this.componentContext && this.componentContext.BBY_doSort) {
      this.componentContext.BBY_doSort();
    } else {
      if (this.widget && this.widget.doSort) {
        this.widget.doSort();
      }
    }
  };

  setFields = (e) => {
    if (this.componentContext && this.componentContext.BBY_doSetFields) {
      this.element.current.classList.add("focus");
      this.componentContext.BBY_doSetFields(e);
    } else {
      if (this.widget && this.widget.doSort) {
        this.widget.doSetFields(window.$(e.currentTarget));
      }
    }
  };

  clearLink = () => {
    if (this.componentContext && this.componentContext.doClearLink) {
      this.componentContext.doClearLink();
    }
  };

  shrink = () => {
    const { widget } = this.state;
    if (this.props.env === "dashboard") {
      let el = BsyUtils.closestClass(this.element.current, "react-grid-item");
      let el2 = BsyUtils.closestClass(this.element.current, "dash-react-block");
      el.classList.remove("block-full-screen");
      el2.classList.remove("block-full-screen");
    } else {
      let el = BsyUtils.closestClass(this.element.current, "react-grid-item");
      if (!el) {
        el = BsyUtils.closestClass(this.element.current, "dash-react-block");
      }
      el.classList.remove("block-full-screen");
      const brot = BsyUtils.closestClass(
        this.element.current,
        "bsy-frame-content"
      );
      if (brot) {
        const leftMenu = document.querySelector(".bsy-frame-menu");
        if (leftMenu) {
          leftMenu.style.display = "";
        }
      }
    }
    this.full = false;
    this.hideTooltip();
    this.setState(
      {
        operates: this.getOperates(widget),
      },
      () => {
        let ee = window.$(".bsy-block-full-screen-mask");
        if (ee) {
          for (let i = 0; i < ee.length; i++) {
            ee[i].style.display = "none";
          }
        }
        if (this.componentContext && this.componentContext.doResize) {
          this.componentContext.doResize();
        }
        this.reMoreOperate();
      }
    );
  };

  enlarge = () => {
    const { widget } = this.state;

    if (this.props.env === "dashboard") {
      let el = BsyUtils.closestClass(this.element.current, "react-grid-item");
      let el2 = BsyUtils.closestClass(this.element.current, "dash-react-block");
      el.classList.add("block-full-screen");
      el2.classList.add("block-full-screen");
    } else {
      let el = BsyUtils.closestClass(this.element.current, "react-grid-item");
      if (!el) {
        el = BsyUtils.closestClass(this.element.current, "dash-react-block");
      }
      el.classList.add("block-full-screen");
      const brot = BsyUtils.closestClass(
        this.element.current,
        "bsy-frame-content"
      );
      if (brot) {
        const leftMenu = document.querySelector(".bsy-frame-menu");
        if (leftMenu) {
          leftMenu.style.display = "none";
        }
      }
    }

    const { widgetId } = widget;

    this.full = true;
    this.hideTooltip();
    this.setState(
      {
        operates: this.getOperates(widget),
      },
      () => {
        let ee = window
          .$(`.${widgetId}`)
          .parent()
          .find(".bsy-block-full-screen-mask");
        if (ee) {
          for (let i = 0; i < ee.length; i++) {
            ee[i].style.display = "block";
          }
        }
        if (this.componentContext && this.componentContext.doResize) {
          this.componentContext.doResize();
        }
        this.reMoreOperate();
      }
    );
  };

  loadWidget = (n, d, s) => {
    this.isload = true;
    if (this.componentContext) {
      if (n === "isFull" && this.props.autoRefresh.enabled) {
        if (
          this.props.onIsElementInViewport &&
          this.props.onIsElementInViewport()
        ) {
          //可视区域内
          this.componentContext.loadWidget &&
            this.componentContext.loadWidget(n, d, s);
        } else {
          this.onLoadFail(n, d);
        }
      } else {
        this.componentContext.loadWidget &&
          this.componentContext.loadWidget(n, d, s);
      }
    } else {
      if (this.widget) {
        this.createNewMap();
      }
    }
  };

  isWidgetLoaded = () => {
    return this.isload;
  };

  refreshSort = () => {
    const { widget, operates, isConfigError } = this.state;
    let operatesold = operates;
    let i = operatesold.indexOf("tooltip");
    if (i > -1) {
      operatesold.splice(i, 1);
    }
    this.setState(
      {
        operates: operatesold,
      },
      () => {
        if (isConfigError) {
          //出现异常错误信息的情况
          this.setState(
            {
              isConfigError: false,
              configErrorTip: "",
            },
            () => {
              if (this.componentContext && this.componentContext.reload) {
                this.componentContext.reload({
                  skip: 0,
                  sort: widget.defaultSort,
                  filter: null,
                });
              }
            }
          );
          return;
        }
        if (this.componentContext && this.componentContext.reload) {
          this.componentContext.reload({
            skip: 0,
            sort: widget.defaultSort,
            filter: null,
          });
        } else {
          // if (this.widget && this.widget.reload) {
          //     this.widget.reload({
          //         skip: 0,
          //         sort: widget.defaultSort,
          //     })
          // }
        }
      }
    );
  };

  create = () => {
    if (this.componentContext && this.componentContext.create) {
      this.componentContext.create(null, {
        menuId: "create",
        menuType: "menu",
      });
    } else {
      if (this.widget && this.widget.doDataCreate) {
        this.widget.doDataCreate();
      }
    }
  };

  export = () => {
    if (this.componentContext && this.componentContext.BBY_doExcelExport) {
      this.componentContext.BBY_doExcelExport();
    }
  };

  customizeAllOperate = () => {
    // this._menuBatchEvnet(menu.menuId,0,[]);
    const { menuId } = this;
    this._menuBatchEvnet(menuId, 1, []);
    this.customizeExitMenuOperate();
  };

  customizeSelectOperate = (menu) => {
    let that = this;
    const { menuId } = this;
    let datas = [];
    let data = [];
    let header = this.componentContext.props.fields;

    if (this.componentContext.state) {
      if (
        this.componentContext.state.level2Menu ||
        this.componentContext.props.multipleChoice
      ) {
        datas = this.componentContext.getSelectDataId
          ? this.componentContext.getSelectDataId()
          : [];
        data = this.componentContext._getCheckData
          ? this.componentContext._getCheckData()
          : [];
      }
    }

    //菜单在没有勾选多选数据的情况下，直接菜单就OK了，不需要弹出确认或者验证勾选数据 2022 06 20 波波
    if (menu !== "batch" && menu && !menu.batchMode && !menu.selectAll) {
      this.checkValiSelect("batchmenu", menuId, datas, (newDatas) => {
        let newD = [];
        if (newDatas) {
          if (newDatas.length === datas.length) {
            newDatas = datas;
            newD = [...data];
          } else {
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              if (newDatas.indexOf(element._id) > -1) {
                newD.push({ ...element });
              }
            }
          }
        } else {
          newDatas = datas;
          newD = [...data];
        }

        that._menuBatchEvnet(menuId, 0, newDatas, header, newD);
      });

      // that.customizeExitMenuOperate();
      return;
    }

    if (BsyUtils.isObjectEmpty(datas)) {
      tipAlert({
        type: "warning",
        msg: React.language("no.data.selected"),
      });
      return false;
    }

    this.checkValiSelect("batchmenu", menuId, datas, (newDatas) => {
      let newD = [];
      if (newDatas) {
        if (newDatas.length === datas.length) {
          newDatas = datas;
          newD = [...data];
        } else {
          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (newDatas.indexOf(element._id) > -1) {
              newD.push({ ...element });
            }
          }
        }
      } else {
        newDatas = datas;
        newD = [...data];
      }
      BsyAlert({
        title: React.language("select.mort.data", {
          num: newD.length,
        }),
        type: "warning",
        text4Ok: React.language("ok"),
        OkType: "blue",
        text4Cancel: React.language("cancel"),
        ok: () => {
          that._menuBatchEvnet(menuId, 0, newDatas, header, newD);
          // that._menuBatchEvnet(menuId, 0, datas, header, data)
          that.customizeExitMenuOperate();
        },
      });
    });
  };

  customizeExitMenuOperate = () => {
    const { widget } = this.state;

    if (this.componentContext && this.componentContext.props.multipleChoice) {
      this.setState(
        {
          operates: this.getOperates(widget),
          operateTitle: "",
        },
        () => {
          this.reMoreOperate();
        }
      );
      return;
    }

    let newWidget = { ...widget, level2Menu: false };
    this.setState(
      {
        operates: this.getOperates(widget),
        operateTitle: "",
        widget: newWidget,
      },
      () => {
        this.reMoreOperate();
      }
    );
  };

  getCustomDashWidget = () => {
    const { block, customDash } = this.state;
    if (!customDash.dash) {
      return {};
    }
    let widget = [];

    BsyUtils.forEach(customDash.dash, (index, data) => {
      if (
        [data.appId, data.entryId, data.widgetId].join("@") ===
        [block.appId, block.entryId, block.widgetId].join("@")
      ) {
        widget.push(data);
      }
    });

    // const widget = customDash.dash.filter((data, index) => {
    //     return [data.appId, data.entryId, data.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@")
    // })

    return widget.length
      ? {
        ...widget[0].widgetParams,
        appId: widget[0].appId,
        entryId: widget[0].entryId,
      }
      : {};
  };

  deleteOperatet = () => {
    let that = this;
    const { widget } = this.state;
    let operate = [];
    if (this.componentContext.state) {
      if (
        this.componentContext.state.level2Menu ||
        this.componentContext.props.multipleChoice
      ) {
        widget.level2Menu = true; //开启多选择开关

        if (that.componentContext) {
          if (BsyUtils.isObjectEmpty(that.componentContext.getSelectDataId())) {
            tipAlert({
              type: "warning",
              msg: React.language("no.data.selected"),
            });
            return false;
          }

          BsyAlert({
            title: React.language("select.delete.data", {
              num: that.componentContext.getSelectDataId().length,
            }),
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
              that.componentContext.BBY_doDeleteData(
                that.componentContext.getSelectDataId()
              );
              this.customizeExitMenuOperate();
            },
          });
        }
      } else {
        widget.level2Menu = true; //开启多选择开关
        operate.push("delSelect");
        operate.push("exitMenu");
        this.setState(
          {
            operates: operate,
          },
          () => {
            this.reMoreOperate();
          }
        );
      }
    }
  };

  // 验证数据表菜单勾选的数据操作权限
  checkValiSelect = (optype, widget, selectDatas, cb) => {
    if (selectDatas && selectDatas.length === 0) {
      cb && cb(selectDatas);
      return true;
    }

    let datas = this.componentContext._getCheckData();
    if (datas && datas.length === 0) {
      cb && cb(selectDatas);
      return true;
    }

    let newDatas = [];

    for (let i = 0; i < datas.length; i++) {
      const row = datas[i];
      if (row.dataPerms) {
        if (row.dataPerms[optype]) {
          if (widget) {
            if (row.dataPerms[optype][widget]) newDatas.push(row._id);
          } else {
            newDatas.push(row._id);
          }
        }
      } else {
        newDatas.push(row._id);
      }
    }

    // BsyUtils.forEach(datas, (key, row) => {
    //     if (row.dataPerms) {
    //         if (row.dataPerms[optype]) {
    //             if (widget) {
    //                 if (row.dataPerms[optype][widget])
    //                     newDatas.push(row._id);
    //             } else {
    //                 newDatas.push(row._id);
    //             }

    //         }
    //     } else {
    //         newDatas.push(row._id);
    //     }
    // })

    if (newDatas.length === selectDatas.length) {
      cb && cb();
      return;
    }

    if (newDatas.length === 0) {
      // this.componentContext.reload()
      this.componentContext.AllCheckContext.setValue(false);
      this.setState(
        {
          selectDatas: newDatas,
        },
        () => {
          BsyAlert({
            title: React.language("data.manager.not.permission"),
            type: "error",
            text4Ok: React.language("ok"),
            OkType: "red",
            ok: () => { },
          });
        }
      );

      return;
    }
    if (newDatas.length !== selectDatas.length) {
      this.selectDatas = [...newDatas];
      this.setState({}, () => {
        // this.componentContext.reload()
        this.selectDatas = [];
        this.componentContext.AllCheckContext.setValue(false);
        BsyAlert({
          title: React.language("data.manager.have.permission.data"),
          msg: React.language("data.manager.have.permission.data.tip", {
            total: selectDatas.length,
            select: newDatas.length,
          }),
          type: "warning",
          text4Ok: React.language("etl.doIt"),
          OkType: "red",
          text4Cancel: React.language("cancel"),
          ok: () => {
            setTimeout(() => {
              cb && cb(newDatas);
            }, 100);
          },
        });
      });

      return;
    }
  };

  customizeOperate = (menu) => {
    const { widget } = this.state;
    let operate = [];
    if (menu.batchMode || menu.selectAll) {
      widget.level2Menu = true; //开启多选择开关
    }

    if (menu.selectAll) {
      operate.push("selectAll");
    }

    if (menu.batchMode) {
      operate.push("batch");
    }
    //区别场景报表 与分析报表，等场景报表重新的统一操作逻辑 2022 03 24 波波
    if (this.componentContext) {
      if (!this.componentContext.state) {
        return;
      }

      //有多选状态
      if (this.componentContext.props.multipleChoice) {
        if (operate.length == 2) {
        } else {
          if (operate.length === 1 && operate[0] === "batch") {
            this.menuId = menu.menuId;
            this.customizeSelectOperate(menu);

            return;
          }
          this.menuId = menu.menuId;
          this.customizeSelectOperate(menu);
          return;
        }
      }

      if (operate.length > 0) {
        operate.push("exitMenu");
        this.menuId = menu.menuId;
        this.setState(
          {
            operates: operate,
            operateTitle: menu.name,
          },
          () => {
            this.reMoreOperate();
          }
        );
        return;
      }

      let datas = [];
      let data = [];
      let header = [];

      if (
        this.componentContext.state.level2Menu ||
        this.componentContext.props.multipleChoice
      ) {
        datas = this.componentContext.getSelectDataId
          ? this.componentContext.getSelectDataId()
          : [];
        data = this.componentContext._getCheckData
          ? this.componentContext._getCheckData()
          : [];
        header = this.componentContext.props.fields;
      }
      this._menuBatchEvnet(menu.menuId, 0, datas, header, data);

      this.reMoreOperate();
    } else {
      this._menuBatchEvnet(menu.menuId, 0, [], [], []);
    }
  };

  reload = (opt) => {
    const { widget } = this.state;
    if (this.componentContext && this.componentContext.reload) {
      switch (widget.type) {
        case "pivot_table": {
          //图表联动的时候 会引起样式错位，需要重新刷新
          this.componentKey = "pivot_table" + window.FX.STATIC.zIndex++;
          this.setState({}, () => {
            this.componentContext.loadWidget(null, null);
          });
          break;
        }
        default: {
          this.componentContext.reload(opt);
          break;
        }
      }
    } else {
      if (this.widget && this.widget.doSort) {
        this.widget.reload();
      }
    }
  };

  etlTooltip = (data) => {
    const { widget } = this.state;
    let that = this;
    this.shouldStopETLInfoPopEvent = !1;
    if (!this.shouldStopETLInfoPopEvent) {
      return that.createETLStatusInfo(
        data,
        "block-custom-operate",
        function () {
          const d1 = BsyUtils.checkRefApp({
            appId: widget.appId,
            entryId: widget.entryId,
            formId: widget.forms[0],
          });
          window.FX.Utils.dataAjax(
            {
              url:
                "/dashboard/app/" +
                (d1.refAppId ? d1.refAppId : d1.appId) +
                "/etl_table/" +
                d1.formId +
                "/refresh",
              data: {
                formId: widget.forms[0],
                popupFormPath: that.popupFormPath.concat({
                  appId: widget.appId,
                  entryId: widget.entryId,
                  formId: widget.forms[0],
                  widgetId: widget.widgetId,
                }),
              },
            },
            function () {
              window.$(".fui_dash_block_popover").remove();
              that.reload({});
            }
          );
        },
        function () {
          that.shouldStopETLInfoPopEvent = !0;
        },
        function () {
          that.shouldStopETLInfoPopEvent = !1;
        },
        widget.dataviewrefresh
      );
    }
  };

  createETLStatusInfo = (e, i, a, n, s, dataviewrefresh) => {
    const FX = window.FX;
    let o = FX.CONST.ETL_STATUS,
      r = "icon-bsy-icongantanhaoxianxing ",
      l = React.language("etl.update.success"),
      c = !0,
      d = !1,
      u = "success";
    if (FX.Utils.isObjectEmpty(e)) return null;
    switch (e.last_status) {
      case o.RUNNING:
        u = "warn";
        r = "icon-loader loader";
        l = React.language("etl.update.running.tip");
        break;
      case o.SUCCESS:
        if (e.has_delay_task) {
          u = "warn";
          l = React.language("not.current.data");
          // let h = parseInt((+new Date(e.delay_task_time) - +new Date) / 1e3 / 60);
          // l = React.language("etl.update.nextRun.tip", {
          //     minutes: h
          // }),
          d =
            FX.Utils.isEmpty(FX.STATIC.ATOKEN) &&
            FX.Utils.isEmpty(FX.STATIC.DASH_TOKEN);
        }
        break;
      case o.FAILURE:
        u = "error";
        l = React.language("etl.update.fail.tip");
        break;
      default:
        c = !1;
    }
    if (!c) return null;

    let mode = "";
    if (e.mode === "time") {
      mode = React.language("refresh.in.time");
    } else if (e.mode === "loop") {
      mode = React.language("cyclic.in.refresh");
    } else if (e.mode === "repeat") {
      let text = "";
      if (e.time.type === "day") {
        text = React.language("data.notify.everyday") + e.time.time;
      } else if (e.time.type === "week") {
        let week = "";
        switch (e.time.week) {
          case "1":
            week = React.language("date.monday");
            break;
          case "2":
            week = React.language("date.tuesday");
            break;
          case "3":
            week = React.language("date.wednesday");
            break;
          case "4":
            week = React.language("date.thursday");
            break;
          case "5":
            week = React.language("date.friday");
            break;
          case "6":
            week = React.language("date.saturday");
            break;
          case "0":
            week = React.language("date.sunday");
            break;
          default: {
          }
        }
        text = React.language("data.notify.everyWeek") + week + e.time.time;
      } else if (e.time.type === "month") {
        let day = e.time.day + React.language("day");
        text = React.language("data.notify.everyMonth") + day + e.time.time;
      } else if (e.time.type === "year") {
        let month = e.time.month + React.language("month");
        let day = e.time.day + React.language("day");
        text =
          React.language("data.notify.everyYear") + month + day + e.time.time;
      }
      mode = React.language("periodic.in.refresh") + text;
    } else {
      mode = React.language("view.refresh.notSet");
    }

    let p = (
      <div className={"operate-btn " + i} ref={this.etlBtn}>
        <i
          className={r + u}
          onMouseEnter={(e) => { }}
          onMouseLeave={(e) => { }}
        />
      </div>
    );

    let f = function (i, a) {
      return window.$("<div/>").append(
        '<div class="line-text">' +
        React.language("etl.lastUpdate", {
          time: FX.Utils.date2Str(
            new Date(e.last_run_time),
            "yyyy-MM-dd HH:mm"
          ),
        }) +
        '</div><div class="line-text">' +
        mode +
        '</div>  <div class="line-text ' +
        i +
        '">' +
        a +
        "</div>"
      );
    };

    setTimeout(() => {
      window.$(this.etlBtn.current).unbind("mouseenter mouseleave");
      new FX.Tooltip({
        renderEl: window.$(this.etlBtn.current),
        hasIcon: !1,
        position: "leftBottomNo",
        popCustomCls: "fui_dash_block_popover",
        onPopContentCreate: function (i) {
          let n = f(u, l).appendTo(i);
          if (d) {
            let s = window.$('<div class="line-btn"/>').appendTo(n);
            if (dataviewrefresh) {
              new FX.Button({
                renderEl: s,
                text: React.language("update.immediately"),
                style: "green",
                width: 78,
                height: 24,
                onClick: function () {
                  FX.Utils.applyFunc(this, a, [], !1);
                  if (!1 !== e.supportUpdate) {
                    i.empty().append(
                      f(u, React.language("etl.update.running.tip"))
                    );
                    i.parent().css("left", i.parent().offset().left + 15);
                  }
                },
              });
            }
          }
        },
        onPopMouseenter: n,
        onPopMouseleave: s,
        anchor: window.$(this.etlBtn.current),
        tipWidth: "auto",
      });
    }, 30);

    return p;
  };

  renderOperateBtn = (data) => {
    const { mode, data_update, floatMenus } = this.state;

    switch (data) {
      case "tooltip": {
        return this.etlTooltip(data_update);
      }
      case "exitMenu": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("dataTable.editor.exit"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn exitMenu"
              onClick={() => {
                this.customizeExitMenuOperate();
              }}
            >
              <i className="icon-signout" />
            </div>
          </>
        );
      }
      case "batch": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("selected.operation"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.customizeSelectOperate(data);
              }}
            >
              <i className={"icon-bsy-reportmenu-0"} />
              <span>{React.language("selected.operation")}</span>
            </div>
          </>
        );
      }
      case "selectAll": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("all.operation"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.customizeAllOperate(data);
              }}
            >
              <i className={"icon-bsy-reportmenu-0"} />
              <span>{React.language("all.operation")}</span>
            </div>
          </>
        );
      }
      case "deleteComponent": {
        if (this.props.env === "dashboard") {
          return (
            <>
              <div
                role={data}
                key={data}
                data-place={"bottom"}
                onMouseEnter={(e) => {
                  this.showTooltip(
                    e.currentTarget,
                    React.language("delete"),
                    "bottom",
                    10
                  );
                }}
                onMouseLeave={() => {
                  this.hideTooltip();
                }}
                className="operate-btn"
                onMouseDown={(e) => {
                  // console.log('onMouseUp onDelComponent')
                  e.stopPropagation();
                  e.preventDefault();
                  this.props.onDelComponent && this.props.onDelComponent(e);
                }}
              >
                <i className="icon-trasho"></i>
              </div>
            </>
          );
        }
        break;
      }
      case "delete": {
        if (mode === "edit") {
          return (
            <>
              <div
                role={data}
                key={data}
                data-place={"bottom"}
                onMouseEnter={(e) => {
                  this.showTooltip(
                    e.currentTarget,
                    React.language("delete"),
                    "bottom",
                    10
                  );
                }}
                onMouseLeave={() => {
                  this.hideTooltip();
                }}
                className="operate-btn"
                onMouseDown={(e) => {
                  // console.log('onMouseUp onDelComponent')
                  e.stopPropagation();
                  e.preventDefault();
                  this.props.onDelComponent && this.props.onDelComponent(e);
                }}
              >
                <i className="icon-trasho"></i>
              </div>
            </>
          );
        } else {
          return (
            <>
              <div
                role={data}
                key={data}
                onMouseEnter={(e) => {
                  this.showTooltip(
                    e.currentTarget,
                    React.language(data),
                    "bottom",
                    10
                  );
                }}
                onMouseLeave={() => {
                  this.hideTooltip();
                }}
                data-place={"bottom"}
                data-type={window.mode}
                data-html={true}
                className="operate-btn"
                onClick={() => {
                  this.deleteOperatet();
                }}
              >
                <i className="icon-trasho"></i>
                <span>{React.language(data)}</span>
              </div>
            </>
          );
        }
      }
      case "delSelect": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("delete.selected"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.deleteOperatet();
              }}
            >
              <i className="icon-trasho"></i>
              <span>{React.language("delete.selected")}</span>
            </div>
          </>
        );
      }
      case "sort": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language(data),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.sort();
              }}
            >
              <i className="icon-bsy-iconpaixu"></i>
            </div>
          </>
        );
      }
      case "setFields": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("field.show"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={(e) => {
                this.setFields(e);
              }}
            >
              <i className="icon-page-view"></i>
            </div>
          </>
        );
      }
      case "shrink": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("zoomOut"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.shrink();
              }}
            >
              <i className="icon-shrink"></i>
            </div>
          </>
        );
      }
      case "clearLink": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("clearLink"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.clearLink();
              }}
            >
              <i className="icon-unlink-alt"></i>
            </div>
          </>
        );
      }
      case "enlarge": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("zoomIn"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.enlarge();
              }}
            >
              <i className="icon-enlarge"></i>
            </div>
          </>
        );
      }
      case "refreshSort": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("refresh"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.refreshSort();
              }}
            >
              <i className="icon-async" />
            </div>
          </>
        );
      }
      case "export": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("export"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.export();
              }}
            >
              <i className="icon-bsy-reportmenu-7" />
              <span>{React.language("export")}</span>
            </div>
          </>
        );
      }
      case "create": {
        return (
          <>
            <div
              role={data}
              key={data}
              onMouseEnter={(e) => {
                this.showTooltip(
                  e.currentTarget,
                  React.language("create"),
                  "bottom",
                  10
                );
              }}
              onMouseLeave={() => {
                this.hideTooltip();
              }}
              data-place={"bottom"}
              data-type={window.mode}
              data-html={true}
              className="operate-btn"
              onClick={() => {
                this.create();
              }}
            >
              <i className="icon-bsy-add" />
              <span>{React.language("create")}</span>
            </div>
          </>
        );
      }
      default: {
        if (this.batchmenuMap && this.batchmenuMap[data]) {
          const { name, icon, tip, menuId } = this.batchmenuMap[data];

          if (floatMenus.length) {
            //重绘操作的时候隐藏超出部门的菜单
            let isHide = false;
            floatMenus.map((dd) => {
              if (dd && dd.menuId === menuId) {
                isHide = true;
              }
              return null;
            });
            if (isHide) {
              return "";
            }
          }
          return (
            <>
              <div
                role={menuId}
                onMouseEnter={(e) => {
                  this.showTooltip(e.currentTarget, tip, "bottom", 10);
                }}
                onMouseLeave={() => {
                  this.hideTooltip();
                }}
                data-place={"bottom"}
                data-type={window.mode}
                data-html={true}
                className="operate-btn"
                onClick={() => {
                  this.customizeOperate(this.batchmenuMap[data]);
                }}
              >
                <i className={"icon-bsy-reportmenu-" + icon} />
                <span>{name}</span>
              </div>
            </>
          );
        }

        return "";
      }
    }
  };

  getFlowMenuData = (dd) => {
    switch (dd) {
      case "exitMenu": {
        return {
          widgetId: dd,
          icon: "icon-signout",
          name: React.language("dataTable.editor.exit"),
        };
      }

      case "delete": {
        return {
          widgetId: dd,
          icon: "icon-trasho",
          name: React.language("delete"),
        };
      }

      case "sort": {
        return {
          widgetId: dd,
          icon: "icon-bsy-iconpaixu",
          name: React.language("sort"),
        };
      }
      case "setFields": {
        return {
          widgetId: dd,
          icon: "icon-page-view",
          name: React.language("field.show"),
        };
      }
      case "clearLink": {
        return {
          widgetId: dd,
          icon: "icon-unlink-alt",
          name: React.language("clearLink"),
        };
      }

      case "refreshSort": {
        return {
          widgetId: dd,
          icon: "icon-async",
          name: React.language("refresh"),
        };
      }
      case "export": {
        return {
          widgetId: dd,
          icon: "icon-bsy-reportmenu-7",
          name: React.language("export"),
        };
      }
      case "create": {
        return {
          widgetId: dd,
          icon: "icon-bsy-add",
          name: React.language("create"),
        };
      }
      case "enlarge": {
        return {
          widgetId: dd,
          icon: "icon-enlarge",
          name: React.language("zoomIn"),
        };
      }
      case "shrink": {
        return {
          widgetId: "icon-shrink",
          icon: "icon-enlarge",
          name: React.language("zoomOut"),
        };
      }
      default: {
        return {
          ...this.batchmenuMap[dd],
          icon: "icon-bsy-reportmenu-" + this.batchmenuMap[dd].icon,
        };
      }
    }
  };

  systemMenuBtn = (data, e) => {
    switch (data.widgetId) {
      case "exitMenu": {
        this.customizeExitMenuOperate();
        break;
      }

      case "delete": {
        this.deleteOperatet();
        break;
      }
      case "delSelect": {
        this.deleteOperatet();
        break;
      }
      case "sort": {
        this.sort();
        break;
      }
      case "setFields": {
        this.setFields(e);
        break;
      }
      case "enlarge": {
        this.enlarge();
        break;
      }
      case "shrink": {
        this.shrink();
        break;
      }
      case "clearLink": {
        this.clearLink();
        break;
      }

      case "refreshSort": {
        this.refreshSort();
        break;
      }
      case "export": {
        this.export();
        break;
      }
      case "create": {
        this.create();
        break;
      }
      default:
        this.customizeOperate(data);
        break;
    }
  };

  flowMenuBtns = (e) => {
    const { floatMenus, widget } = this.state;
    let menu = [];
    floatMenus.map((data) => {
      let dd = this.getFlowMenuData(data);
      menu.push({
        text: dd.name,
        colorType: "",
        icon: dd.icon, //'icon-bsy-reportmenu-' + dd.icon,
        click: () => {
          this.systemMenuBtn(dd, e);
        },
        onMouseEnter: (event) => {
          if (dd.tip) {
            window.FX.UI.showPopover({
              position: "bottomLeft",
              anchor: window.$(event.target),
              content: window.$("<span />").text(dd.tip),
              type: "dark",
            });
          }
        },
        onMouseLeave: () => {
          if (dd.tip) {
            window.FX.UI.closePopover();
          }
        },
      });
      return null;
    });

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: e.currentTarget,
      theme: widget.theme,
    });
  };

  renderOperateBtns = () => {
    const { widget, operates, operateTitle, mode, data_update } = this.state;
    let newOperate = [];

    // if (operates[0] === "tooltip") {
    //     operates.splice(0, 1)
    //     newOperate = []
    //     let flag = true
    //     operates.map((res) => {
    //         if (flag && (res === "exitMenu" || res === "batch" || res === "selectAll" || res === "delete" || res === "delSelect" || res === "sort" || res === "setFields" || res === "shrink" || res === "enlarge" || res === "refreshSort" || res === "export" || res === "create")) {
    //             flag = false;
    //             newOperate.push("tooltip")
    //         }
    //         newOperate.push(res)
    //         return null;
    //     })
    // }else{

    // }
    let custom = [];
    let system = [];
    if (data_update) {
      system.push("tooltip");
    }
    for (let i = 0; i < operates.length; i++) {
      let dr = operates[i];
      if (dr.indexOf("_widget_") > -1) {
        custom.push(dr);
      } else {
        if (dr !== "tooltip") {
          system.push(dr);
        }
      }
    }
    newOperate = [...custom, ...system];

    // if (newOperate.length <= 0) {
    //     if (mode !== 'edit') {
    //         if (data_update) {
    //             if (operates.indexOf('tooltip') === -1) {
    //                 newOperate = ['tooltip', ...operates];
    //             } else {
    //                 operates.remove('tooltip');
    //                 newOperate = ['tooltip', ...operates];
    //             }
    //         } else {
    //             newOperate = operates;
    //         }
    //     } else {
    //         newOperate = operates;
    //     }
    // }
    if (mode !== "edit" && this.props.env !== "dashboard") {
      if (!this._checkFieldsValid(widget)) {
        return "";
      }
    }

    if (this.props.env === "dashboard") {
      newOperate.push("deleteComponent");
    }

    return (
      <div className="block-operate" ref={this.refOptBtn}>
        {operateTitle ? (
          <div className="operate-btn-title">{operateTitle}</div>
        ) : (
          ""
        )}
        {!widget.level2Menu && operates.length > 0 && (
          <div
            onMouseEnter={(e) => {
              this.showTooltip(
                e.currentTarget,
                React.language("more"),
                "bottom",
                10
              );
            }}
            onMouseLeave={() => {
              this.hideTooltip();
            }}
            data-place={"bottom"}
            data-type={window.mode}
            data-html={true}
            className="operate-more"
            onClick={this.flowMenuBtns}
            style={{ display: "block" }}
          >
            <i className="icon-bsy-icongengduo1" />
          </div>
        )}
        {newOperate.map((data) => {
          return this.renderOperateBtn(data);
        })}
      </div>
    );
  };

  _hasExport = (t) => {
    if (
      t.type === "data_table" ||
      t.type === "rili" ||
      t.type === "pivot_table"
    ) {
      return t.exportable && this._checkFieldsValid(t);
    }
    return "data_manage" === t.type
      ? t.dataPerms && (t.dataPerms.export || t.dataPerms.flow_export)
      : t.hasExport && /table/.test(t.type) && this._checkFieldsValid(t);
  };

  _hasClearLink = (t) => {
    return (
      !/_filter$/.test(t.type) &&
      (!BsyUtils.isObjectEmpty(t.triggers) ||
        !BsyUtils.isObjectEmpty(t.customizeTriggers))
    );
  };

  getOperates = (widget) => {
    let that = this;
    let operate = [];

    this.batchmenuMap = this.batchmenuMap || {};
    if (
      widget.batchmenu &&
      widget.batchmenu.enable &&
      !BsyUtils.isObjectEmpty(widget.batchmenu.set)
    ) {
      BsyUtils.forEach(widget.batchmenu.set, function (t1, e1) {
        if (widget.batchmenuAuth && widget.batchmenuAuth[e1.menuId]) {
          // z += i._getOperateCustomizeBtn(e1);
          that.batchmenuMap[e1.menuId] = e1;
          operate.push(e1.menuId);
        }
      });
    }
    //2022 03 25  新建权限不对？
    // if ((widget.type === "rili" || widget.type === "newMap") && widget.origin === "dash") {
    //     if (widget.reportAuth && widget.reportAuth.length > 0 && widget.reportAuth[1] && widget.reportAuth[1].dataPerms && widget.reportAuth[1].dataPerms.create) {
    //         widget.itemAddable = true
    //     }
    // }

    if (widget.dataPerms) {
      (widget.dataPerms.create || widget.dataPerms.flow_create) &&
        operate.push("create");
      widget.dataPerms.import && operate.push("import");
    }

    this._hasClearLink(widget) && operate.push("clearLink");
    this._hasExport(widget) && operate.push("export");
    if (widget.itemAddable) operate.push("create");
    if (widget.dataPerms || widget.itemRemovable) {
      (widget.itemRemovable ||
        widget.dataPerms.delete ||
        widget.dataPerms.flow_delete) &&
        operate.push("delete");
    }

    if (this._hasSort(widget)) {
      operate.push("refreshSort");

      if (widget.type === "metric_table") {
        if (widget.xFields.length > 0) {
          operate.push("sort");
        }
      } else if (
        "map_chart" !== widget.type &&
        "newrili" !== widget.type &&
        "rili" !== widget.type &&
        "funnel_chart" !== widget.type
      ) {
        operate.push("sort");
      }
    }

    if (
      widget.type === "data_table" ||
      widget.type === "newrili" ||
      widget.type === "rili" ||
      widget.type === "background_table" ||
      widget.type === "card"
    )
      operate.push("setFields");

    widget.forms &&
      widget.forms[0] &&
      this._checkFieldsValid(widget) &&
      (this.full ? operate.push("shrink") : operate.push("enlarge"));

    // this.setState({
    //     operates: [...operate]
    // })
    // console.log("operate", operate);
    return operate;
  };

  // _hasSort = (t) => {
  //   return (
  //     !(
  //       ("metric_table" === t.type ||
  //         "gauge_chart" === t.type ||
  //         "funnel_chart" === t.type) &&
  //       t.xFields.length <= 0
  //     ) &&
  //     (/chart/.test(t.type) ||
  //       /table/.test(t.type) ||
  //       /newMap/.test(t.type) ||
  //       /card/.test(t.type) ||
  //       /rili/.test(t.type) ||
  //       /gantt/.test(t.type)) &&
  //     this._checkFieldsValid(t)
  //   );
  // };

  _hasSort = (config) => {
    // 不支持的图表类型
    const unsupportedTypes = new Set(['gauge_chart', 'funnel_chart']);
    const isUnsupported = unsupportedTypes.has(config.type) && config.xFields.length <= 0;

    // 支持的图表类型模式
    const supportedPatterns = [/chart/, /table/, /newMap/, /card/, /rili/, /gantt/];
    const isSupportedType = supportedPatterns.some(pattern => pattern.test(config.type));

    return !isUnsupported && isSupportedType && this._checkFieldsValid(config);
  };

  _checkFieldsValid = (t) => {
    if (BsyUtils.isObjectEmpty(t)) return !1;
    let e = !0;
    switch (t.type) {
      case "line_chart":
      case "column_chart":
      case "bar_chart":
      case "funnel_chart":
      case "area_chart":
      case "radar_chart":
      case "pie_chart":
      case "map_chart":
        e =
          (t.xFields.length > 0 || t.yFields.length > 0) &&
          t.metrics.length > 0;
        break;
      case "pivot_table":
        e =
          t.xFields.length > 0 || t.yFields.length > 0 || t.metrics.length > 0;
        break;
      case "multi_axes_chart":
        e = t.xFields.length > 0 && t.metrics.length > 0;
        break;
      case "metric_table":
      case "gauge_chart":
        e = t.metrics.length > 0;
        break;
      case "data_table":
      case "rili":
      case "newrili":
        e = t.fields && t.fields.length > 0;
        break;
      default: {
      }
    }
    return e;
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  onRefreshChars = (opt) => {
    if (this.props.onRefreshChars) {
      this.props.onRefreshChars(opt);
    }
  };

  onDataFilter = () => {
    // BsyUtils.applyFunc(this, this.props.onDataFilter, [], !1);
    let t = [];
    this.filter && (t = t.concat(this.filter));
    this.linkFilter && (t = t.concat(this.linkFilter));
    return {
      filter: t,
      filterMap: this.filterMap,
      rel: this.context && this.context.getOverallSituationValue("rel"),
    };
  };

  _dealValueFields = (e) => {
    let i = this;
    let a = [];
    BsyUtils.forEach(e, function (e, n) {
      a.push(
        window.$.extend(
          {
            text: i._getFieldText(n),
          },
          n
        )
      );
    });
    return a;
  };

  createNewMap = () => {
    let e = this.state.widget;
    let a = this.props;
    let t = window.$;
    let FX = window.FX;
    let _this = this;
    t(this.blockContent.current).empty();
    let data = t.extend(e, {
      renderEl: t('<div class="component-content"/>').appendTo(
        t(this.blockContent.current)
      ),
      hasHeader: !1,
      hasBorder: !1,
      widgetName: e.widgetId,
      width: t(this.blockContent.current).width(),
      height: t(this.blockContent.current).height(),
      range: a.range || a.widget.range,
      pointerColor: a.pointerColor || a.widget.pointerColor,
      changeMethod: a.widget.changeMethod,
      // styles:style,
      styles: a.widget.styles,
      ptlist: a.widget.ptlist,
      readData: a.widget.readData,
      sizeX: a.widget.width,
      sizeY: a.widget.height,
      ganttFields: a.widget.ganttFields,
      taskIdField: a.widget.taskIdField,
      taskDependenciesField: a.widget.taskDependenciesField,
      zoomLevel: a.widget.zoomLevel,
      chart_label: a.widget.chart_label,
      drilling: a.widget.drilling,
      cardConfig: a.widget.cardConfig,
      formulas: a.widget.formulas,
      cardConfigFields: a.widget.cardConfigFields,
      summaryTitleAlignment: a.widget.summaryTitleAlignment,
      mapfields: a.mapfields,
      valueFields: this._dealValueFields(a.widget.metrics),
      menu: a.widget.menu,
      scopefields: e.scopefields,
      onSwitchButton: e.onSwitchButton,
      BtnName: e.BtnName,
      FunctionBtn: e.FunctionBtn,
      DataMode: e.DataMode,
      itemSeleable: e.itemSeleable,
      itemMarekerable: e.itemMarekerable,
      itemDataable: e.itemDataable,
      mapScale: e.mapScale,
      reportAuth: e.reportAuth,
      permission: a.widget.permission,
      background: a.widget.background,
      chartType: e.type,
      thresholds: "all" === a.widget.permission ? a.thresholds : [],
      attrList: a.widget.attrList,
      popupFormPath: this.popupFormPath,
      onIsAutoLoad: function () {
        if (_this.props.onIsAutoLoad) return _this.props.onIsAutoLoad;
        else return !0;
      },
      onOperateTrigger: function () {
        // console.log(t)
      },
      onRefreshChars: function (chars) {
        return _this.onRefreshChars(chars);
      },
      onLoadFail: function (t) {
        _this.blockContent.current.innerHTML = "";
        setTimeout(() => {
          _this.onConfigError(t.responseJSON);
        }, 20);

        return _this.onLoadFail(t);
      },
      onLoadSuccess: function (t) {
        return _this.onLoadSuccess(t);
      },
      onDataFilter: function (t) {
        console.log(888, t);
        return _this.onDataFilter();
      },
      onFormat: function () {
        // return FX.Utils.applyFunc(i, a.onFormat, [f,h,o], !1)
      },
      onLoadNull: function () {
        // i.exception = !1;
        // i._triggerException()
      },
      componentAttr: FX.Utils.pick(e, [
        "posX",
        "posY",
        "height",
        "width",
        "type",
        "formulas",
        "menu",
        "batchmenu",
      ]),
    });
    // console.log(data)
    this.widget = FX.createWidget(data);
  };

  onConfigError = ({ msg }) => {
    this.setState({
      isConfigError: true,
      configErrorTip: msg,
    });
  };

  renderBlockContent = () => {
    const {
      widget,
      isConfigError,
      mode,
      configErrorTip,
      is_dock_form,
      allComponentDash,
    } = this.state;
    if (isConfigError || !this._checkFieldsValid(widget)) {
      this.isload = false;
      return (
        <BsyDashComponentEmpty
          {...widget}
          configErrorTip={configErrorTip}
          getContext={this.getContext}
          onLoadFail={this.onLoadFail}
        ></BsyDashComponentEmpty>
      );
    }
    switch (widget.type) {
      case "data_table": {
        // case "background_table":
        if (widget.hasOwnProperty("quickEdit")) {
          if (!widget.quickEdit) {
            let fields = [];
            for (let i = 0; i < widget.fields.length; i++) {
              let field = widget.fields[i];

              if (field.type == "subform") {
                let subfields = [];
                for (let i1 = 0; i1 < field.items.length; i1++) {
                  let subfield = field.items[i1];
                  if (subfield.type != "button") {
                    subfields.push(subfield);
                  }
                }
                field.items = subfields;
                fields.push(field);
              } else if (field.type != "button") {
                fields.push(field);
              }
            }

            widget.fields = fields;
          }
        }

        return (
          <BsyDataTable
            key={this.componentKey}
            {...widget}
            // enableRowEdit={true} //2023 03 11 波波临时测试
            selectDataId={this.selectDatas ? this.selectDatas : []}
            origin={"report"}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRowMenuEvent={this.onRowMenuEvent}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
            componentAttr={BsyUtils.pick(widget, [
              "posX",
              "posY",
              "height",
              "width",
              "type",
              "formulas",
              "menu",
              "batchmenu",
            ])}
            onReload={() => {
              // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 03 25 波波
              this.componentKey = "table" + window.FX.STATIC.zIndex++;
              this.skip = this.componentContext.state.skip;
              this.setState({}, () => {
                this.componentContext.loadWidget(null, null, this.skip);
              });
            }}
          />
        );
      }
      case "pivot_table": {
        return (
          <BsyPivotTable
            key={this.componentKey}
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            url={"/data/report_combined_group"}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
            onReload={(skip, resultData) => {
              // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 03 25 波波
              this.componentKey = "pivot_table" + window.FX.STATIC.zIndex++;
              let scrollLeft = this.componentContext.scrollLeft;
              this.setState({}, () => {
                //根据数据直接重构组件
                this.componentContext.scrollLeft = scrollLeft;
                this.componentContext.dataReload(skip, resultData);
              });
            }}
          />
        );
      }
      case "gantt": {
        return (
          <BsyGantt
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            url={"/data/report_gantt_list"}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }

      case "bar_chart":
      case "column_chart": {
        return (
          <BsyDashBarChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "line_chart": {
        return (
          <BsyDashLineChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "pie_chart": {
        return (
          <BsyDashPieChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "area_chart": {
        return (
          <BsyDashAreaChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "radar_chart": {
        return (
          <BsyDashRadarChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "multi_axes_chart": {
        return (
          <BsyDashMultiAxesChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "map_chart": {
        return (
          <BsyDashMapChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }

      case "funnel_chart": {
        return (
          <BsyDashFunnelChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "gauge_chart": {
        return (
          <BsyDashGaugeChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            isDashFull={this.isDashFull}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            // url={'/data/report_gantt_list'}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onItemClick={this.props.onItemClick}
            onClearLink={this.props.onClearLink}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }

      case "newrili":
      case "rili": {
        widget.type = "newrili";
        return (
          <BsyDashRiliChart
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            url={
              widget.mode === "edit"
                ? "/data/report_preview_rili_list"
                : "/data/report_rili_list"
            }
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }

      case "description": {
        return (
          <BsyDashDescription
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }

      case "image": {
        return (
          <BsyDashImage
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }
      case "gauge_imageMore": {
        return (
          <BsyDashImageMore
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            width={this.props.width}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }
      case "real_time": {
        return (
          <BsyDashRealTime
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }
      case "embedded_iframe": {
        return (
          <BysDashEmbeddedIframe
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onFullScreen={() => {
              if (this.full) {
                this.shrink();
              } else {
                this.enlarge();
              }
              return this.full;
            }}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }
      case "metric_table": {
        return (
          <BsyMetricTable
            {...widget}
            env={this.props.env}
            is_dock_form={is_dock_form}
            isDashFull={this.isDashFull}
            autoLoad={this.props.autoLoad}
            autoRefresh={this.props.autoRefresh}
            mountAutoLoad={this.props.mountAutoLoad}
            popupFormPath={this.popupFormPath}
            onItemClick={this.props.onItemClick}
            getContext={this.getContext}
            _menuBatchEvnet={this._menuBatchEvnet}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onGetStyles={this.props.onGetStyles}
            onDataFilter={this.onDataFilter}
            onConfigError={this.onConfigError}
          />
        );
      }
      case "text_filter": {
        return (
          <BsyFilterText
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterText>
        );
      }
      case "combocheck_filter": {
        return (
          <BsyFilterComboCheck
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterComboCheck>
        );
      }
      case "textarea_filter": {
        return (
          <BsyFilterTextArea
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterTextArea>
        );
      }

      case "filelist_filter": {
        return (
          <BsyFilterFile
            {...widget}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFile>
        );
      }

      case "user_filter": {
        return (
          <BsyFilterUser
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterUser>
        );
      }
      case "number_filter": {
        return (
          <BsyFilterNumber
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterNumber>
        );
      }

      case "flowstate_filter": {
        return (
          <BsyFilterFlowState
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowState>
        );
      }
      case "assist_prostatus_filter": {
        return (
          <BsyFilterFlowAssistProstatus
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowAssistProstatus>
        );
      }
      case "assist_flowid_filter": {
        return (
          <BsyFilterFlowAssistFlowid
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowAssistFlowid>
        );
      }

      case "flowdecision_filter": {
        return (
          <BsyFilterFlowDecision
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowDecision>
        );
      }

      case "address_district_filter":
      case "address_filter": {
        return (
          <BsyFilterAddress
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            format={"pcd"}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "address_province_filter": {
        return (
          <BsyFilterAddress
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            format={"p"}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "address_city_filter": {
        return (
          <BsyFilterAddress
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            format={"pc"}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "usergroup_filter": {
        return (
          <BsyFilterUserGroup
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterUserGroup>
        );
      }

      case "dept_filter": {
        return (
          <BsyFilterDept
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDept>
        );
      }
      case "deptgroup_filter": {
        return (
          <BsyFilterDeptGroup
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDeptGroup>
        );
      }

      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        return (
          <BsyFilterDate
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDate>
        );
      }
      case "filte_quick": {
        return (
          <BsyFilteQuick
            {...widget}
            is_dock_form={is_dock_form}
            popupFormPath={this.popupFormPath}
            onGetStyles={this.props.onGetStyles}
            allComponentDash={allComponentDash}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onLoadFail={this.onLoadFail}
            onChooseUpItem={this.props.onChooseUpItem}
          ></BsyFilteQuick>
        );
      }
      case "filter_btn": {
        return (
          <BsyFilterBtn
            is_dock_form={is_dock_form}
            onGetStyles={this.props.onGetStyles}
            onClick={this.props.onClick}
            onClear={this.props.onClear}
          />
        );
      }
      case "card": {
        return (
          <BsyDashCard
            {...widget}
            is_dock_form={is_dock_form}
            key={this.componentKey}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            _menuBatchEvnet={this._menuBatchEvnet}
            onRowMenuEvent={this.onRowMenuEvent}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onDataFilter={this.onDataFilter}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            onReload={() => {
              // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 03 25 波波
              this.componentKey = "card" + window.FX.STATIC.zIndex++;
              this.skip = this.componentContext.state.skip;
              this.setState({}, () => {
                this.componentContext.loadWidget(null, null, this.skip);
              });
            }}
          />
        );
      }
      case "newMap": {
        return (
          <BsyDashMap
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            _menuBatchEvnet={this._menuBatchEvnet}
            onRowMenuEvent={this.onRowMenuEvent}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onDataFilter={this.onDataFilter}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }
      case "base_layout_container": {
        return (
          <BsyDashBaseLayoutContainer
            {...widget}
            allComponentDash={allComponentDash}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            _menuBatchEvnet={this._menuBatchEvnet}
            onRowMenuEvent={this.onRowMenuEvent}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onDataFilter={this.onDataFilter}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
            // widgetsMap={this.props.widgetsMap}
            widgetsObject={this.props.widgetsObject}
            widgetsValue={this.props.widgetsValue}
            mode={mode}
            globFilter={this.props.globFilter}
            overallBlocks={this.props.overallBlocks}
            overalDashList={this.props.overalDashList}
            // rel={this.rel}
            overallBlockMap={this.props.overallBlockMap}
          // refreshMap={this.refreshMap}
          // refresWidgetMapTime={this.refresWidgetMapTime}
          // refreshNewUpdataTime={this.refreshNewUpdataTime}
          />
        );
      }
      case "webPage": {
        return (
          <BsyDashWebPage
            {...widget}
            is_dock_form={is_dock_form}
            autoLoad={this.props.autoLoad}
            isDashFull={this.isDashFull}
            autoRefresh={this.props.autoRefresh}
            popupFormPath={this.popupFormPath}
            _menuBatchEvnet={this._menuBatchEvnet}
            onRowMenuEvent={this.onRowMenuEvent}
            getContext={this.getContext}
            onRefreshChars={this.onRefreshChars}
            onLoadSuccess={this.onLoadSuccess}
            onDataFilter={this.onDataFilter}
            onLoadFail={this.onLoadFail}
            onIsAutoLoad={this.props.onIsAutoLoad}
          />
        );
      }

      default: {
        console.log(widget.type);
      }
    }
  };

  onFilterStopEdit = (t) => {
    BsyUtils.applyFunc(this, this.props.onStopEdit, [t], !1);
  };

  onLoadSuccess = (data, n, d) => {
    const { operates, mode, widget } = this.state;
    if (mode !== "edit") {
      if (data.data_update) {
        if (operates.indexOf("tooltip") === -1) {
          let newoperates = ["tooltip", ...operates];
          this.setState({
            operates: newoperates,
            data_update: { ...data.data_update },
          });
        } else {
          this.setState({
            data_update: { ...data.data_update },
          });
        }
      }
      this.isload = !0;
      BsyUtils.applyFunc(
        this,
        this.props.onLoadSuccess,
        [widget.widgetId, n, d],
        !1
      );
    }
  };

  onLoadFail = (n, d) => {
    const { mode, widget } = this.state;
    if (mode !== "edit") {
      this.isload = !0;
      BsyUtils.applyFunc(
        this,
        this.props.onLoadSuccess,
        [widget.widgetId, n, d],
        !1
      );
    }
  };

  renderHeader = (widget) => {
    if (!widget.type) {
      return <></>;
    }
    if (widget.type.indexOf("filter") === -1) {
      return (
        <div className={"block-head "} ref={this.refHeader}>
          {this.renderTitle()}

          {this.renderOperateBtns()}
        </div>
      );
    }
    return <></>;
  };

  render() {
    const { widget } = this.state;
    //
    return (
      <div
        ref={this.element}
        className={"bsy_dash_block"}
        key={"BsyDashComponent-" + widget.widget}
      >
        {widget.type !== "webPage" && this.renderHeader(widget)}

        {widget.type && (
          <div
            className={
              "block-content" +
              (widget.type.indexOf("filter") > -1 ? " bsy-filter-base " : "") +
              " bsy-" +
              widget.type
            }
            ref={this.blockContent}
          >
            {this.renderBlockContent()}
          </div>
        )}
      </div>
    );
  }

  onResetRel = (t) => {
    if (this.pupupDashContext && this.pupupDashContext.setRel)
      this.pupupDashContext.setRel(t);
  };

  onResetFilter = () => {
    this.pupupDashContext.ResetFilter();
  };

  getPupupDashContext = (content) => {
    this.pupupDashContext = content;
  };

  onMessage = (event) => {
    // console.log(event);

    if (event.data && "token" in event.data) {
      if (event.data.token === "printed-close") {
        this.showPane.closeAlter();
      }
    }
  };

  onDocumentClick = () => {
    window.removeEventListener("click", this.onDocumentClick, false);
    if (this.showPane) {
      this.showPane.closeAlter();
      this.showPane = null;
    }
    console.log("onDocumentClick 清理打印窗口");
  };

  _getPrintField = () => {
    var { fields } = this.state.widget;

    var printffields = [];
    BsyUtils.forEach(fields, function (a1, b1) {
      if (b1) {
        if (b1.type != "subform") {
          printffields.push(b1.name);
        } else {
          BsyUtils.forEach(b1.items, function (a2, b2) {
            printffields.push([b1.name, b2.name].join("."));
          });
        }
      }
    });
    var fields1 = [];
    BsyUtils.forEach(printffields, function (a1, b1) {
      if (["flowState", "chargers"].indexOf(b1) == -1) {
        fields1.push(b1);
      }
    });
    return fields1;
  };

  _doPrint = (c, printId, data) => {
    var b = this;
    var { widget: c } = this.state;
    console.log("menu  555 ");
    if (!this.isPrinting) {
      this.isPrinting = !0;
      var d1 = BsyUtils.checkRefApp({
        appId: window.FX.STATIC.APPID,
        entryId: window.FX.STATIC.ENTRYID,
        formId: c.forms ? c.forms[0] : c.entryId,
      });

      let layerRef = null;
      BsyMaskLayer({
        // customCls: 'fadein-right',
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <div>
              <BsySLoading />{" "}
            </div>
          );
        },
      });
      if (this.showPane) {
        window.removeEventListener("message", b.onMessage, false);
        this.showPane.closeAlter();
        this.showPane = null;
      } else {
        this.showPane = null;
      }
      console.log("menu  6666 ");
      let theme = "";
      var d = BsyUtils.isSupportPdf();
      React.axios("/data/_print", {
        scenes: "report",
        showFields: this._getPrintField(),
        appId: d1.appId,
        entryId: d1.entryId,
        formId: d1.formId || d1.entryId,
        refAppId: d1.refAppId,
        isAttachment: BsyUtils.isDingdingBrowser() ? false : !d,
        popupFormPath: b.props.popupFormPath
          ? [
            {
              appId: c.appId || window.FX.STATIC.APPID,
              entryId: c.entryId || window.FX.STATIC.ENTRYID,
              formId: c.forms[0],
              widgetId: c.widgetId,
            },
          ]
          : [
            ...b.props.popupFormPath,
            {
              appId: c.appId || window.FX.STATIC.APPID,
              entryId: c.entryId || window.FX.STATIC.ENTRYID,
              formId: c.forms[0],
              widgetId: c.widgetId,
            },
          ],

        dataId: data._id,
        printId: printId,
      })
        .then((res) => {
          b.isPrinting = false;
          layerRef.close();
          console.log("menu  7777 ");
          if ("template" === res.data.printType) {
            var s;
            var title = "";
            var c = res.data;
            if (res.data.url.indexOf("readpdf") > -1) {
              title = React.language("data.pdf");
              // if (BsyUtils.popupPrint()) {
              theme = "bsy-x-slider-hide";
              // window.addEventListener("message", b.onMessage, false);
              window.addEventListener("click", b.onDocumentClick, false);

              let url =
                `${window._bby_config.site}${window.rootDirectroy}template/formreport/static/js/pdfjs-3.7.107/web/pdf-print1.html?v=20241030&file=` +
                encodeURIComponent(
                  `${window._bby_config.site}${window.rootDirectroy}${res.data.url}`
                );

              s = (
                <iframe
                  src={url}
                  title={title}
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                  }}
                  frameborder={"0"}
                />
              );
              // } else {
              //   s = (
              //     <embed
              //       src={res.data.url}
              //       width="100%"
              //       height="100%"
              //       style={{ position: "absolute" }}
              //       type="application/pdf"
              //     />
              //   );
              // }
            } else {
              var officeurl =
                window._bby_config.office_domain || "office.baibaoyun.com";
              var url = "";
              if (c.url.indexOf("readword") > -1) {
                url =
                  "https://" +
                  officeurl +
                  "/op/view.aspx?src=" +
                  encodeURIComponent(window.location.origin + res.data.url);
              } else {
                url =
                  "https://" +
                  officeurl +
                  "/op/view.aspx?src=" +
                  encodeURIComponent(res.data.url);
              }
              s = (
                <iframe
                  className="file-box-preview"
                  src={url}
                  title={title}
                  frameborder="0"
                  style={{ width: "100%", height: "100%" }}
                />
              );
              title = React.language("data.word");
            }
            if (d) {
              BsySlidePane({
                title: title,
                hasHeader: true,
                theme: theme,
                onClose: () => {
                  window.removeEventListener("message", b.onMessage, false);
                },
                onContentCreate: (ref) => {
                  b.showPane = ref;
                  const url = `${res.data.url}?filename=${res.data.filename}`;
                  return (
                    <>
                      <div className="preview-print-title">
                        <div className="fileName">{res.data.filename}</div>
                        <a className="fileDownloadBtn" href={url}>
                          <i clclassNameass="icon-download"></i>
                          {React.language("download")}
                        </a>
                      </div>
                      {s}
                    </>
                  );
                },
              });
            } else {
              if (BsyUtils.isDingdingBrowser()) {
                React.axios("/sso/getJumpUrl", {
                  url: c.url,
                }).then((res) => {
                  BsyUtils.redirectTo(res.data.url, "_blank");
                });
                return;
              } else {
                BsyUtils.redirectTo(c.url);
              }
            }
          }
        })
        .catch((res) => {
          console.error(res);
          layerRef.close();
          b.isPrinting = false;
        });
    }
  };

  print = (menuId, menu, rowdata, action, cb, event) => {
    if (!menu.extendSet) return;

    let config = { ...menu.extendSet };
    let ptlist = [];
    BsyUtils.forEach(config.print, function (a1, b1) {
      ptlist.push({
        printId: a1,
        name: b1.name,
      });
    });

    if (BsyUtils.isObjectEmpty(ptlist)) {
      tipAlert({
        msg: React.language("flow.list.multiNode22"),
        type: "warning",
      });
      return;
    }
    let _this = this;
    // let _opt = this.options;

    var d1 = BsyUtils.checkRefApp({
      appId: window.FX.STATIC.APPID,
      entryId: menu.extendSet.formId,
      formId: menu.extendSet.formId,
    });

    if (ptlist.length === 1) {
      _this._doPrint(d1, ptlist[0].printId, rowdata);
    } else {
      let menu = [];
      BsyUtils.forEach(ptlist, (a1, b1) => {
        menu.push({
          text: b1.name,
          colorType: "",
          icon: "",
          click: () => {
            _this._doPrint(d1, b1.printId, rowdata);
          },
        });
      });

      let currentTarget =
        event.currentTarget || BsyUtils.closestClass(event.target, "BsyBtn");

      BsyAlertMenu({
        item: menu,
        width: 220,
        // height: 210,
        position: {
          top: event.clientY,
          left: event.clientX,
        },
        target: currentTarget,
        onClose: () => { },
      });
    }
  };

  //---- 统一报表 单行数据的处理逻辑 ----

  onRowMenuEvent = (menu, rowdata, reftype, event) => {
    const { widget, mode } = this.state;

    if (mode === "preview") {
      return;
    }

    let that = this;
    let menuId = menu.menuId; // + "_" + dataIndex;
    // let rowdata = { ...that.AllData[ddrow.dataIndex] }

    const cefield = [...widget.fields, ...(widget.cardConfigFields || [])]

    BsyUtils.forEach(cefield, (index, data) => {
      if (rowdata.hasOwnProperty(data.tag))
        rowdata[data.name] = rowdata[data.tag];
    });

    let detailOnly = false;
    BsyUtils.forEach(cefield, function (a1, b1) {
      if (b1.detailOnly) {
        detailOnly = true;
        return !1;
      }
    });

    // BsyUtils.forEach(widget.fields, (index, data) => {
    //   if (rowdata.hasOwnProperty(data.tag))
    //     rowdata[data.name] = rowdata[data.tag];
    // });

    // let detailOnly = false;
    // BsyUtils.forEach(widget.fields, function (a1, b1) {
    //   if (b1.detailOnly) {
    //     detailOnly = true;
    //     return !1;
    //   }
    // });

    if (
      reftype !== "etl_table" &&
      reftype !== "aggregate_table" &&
      menu.type === "print"
    ) {
      that.print(menuId, menu, rowdata, 0, that.rowMenuCallback, event);
      return;
    }

    if (
      !detailOnly ||
      reftype === "etl_table" ||
      reftype === "aggregate_table"
    ) {
      switch (menu.type) {
        case "event":
        case "module":
        case "datahelp": {
          if (menu.alert && menu.alertinfo.msg) {
            window.FX.Msg.alert({
              // title: ,
              title: menu.alertinfo.msg,
              type: menu.alertinfo.icon,
              onOk: function () {
                that.BBY_RowMenuEvent(
                  menuId,
                  menu,
                  rowdata,
                  0,
                  that.rowMenuCallback
                );
              },
              onCancel: function () { },
            });
          } else {
            that.BBY_RowMenuEvent(
              menuId,
              menu,
              rowdata,
              0,
              that.rowMenuCallback
            );
          }
          break;
        }

        case "popupform": {
          that.BBY_RowMenuEvent(menuId, menu, rowdata, 0, that.rowMenuCallback);
          break;
        }

        case "popupreport": {
          window.FX.STATIC.APPID = widget.appId;
          window.FX.Utils.dataAjax(
            {
              url:
                "/dashboard/app/" +
                window.FX.STATIC.APPID +
                "/entry/" +
                menu.reportId,
              data: {
                popupFormPath: that.popupFormPath.concat({
                  appId: widget.appId,
                  formId: widget.forms[0],
                  entryId: widget.entryId,
                  widgetId: widget.widgetId,
                }),
              },
            },
            function (f) {
              let h = f.entry;
              // let rel = h.rel || 'and';
              let rel =
                (that.context &&
                  that.context.getOverallSituationValue("rel")) ||
                "and";
              BsyUtils.forEach(h.components, (key, value) => {
                if (BsyUtils.isObjectEmpty(value)) {
                  delete h.components[key];
                }
              });
              BsyUtils.forEach(that.filterMap, function (a1, b1) {
                rowdata[a1] = b1;
              });
              window.FX.Utils._filterDefaultReplace(h, menu, rowdata);
              const allComponentDash = _.cloneDeep({
                ...f,
                appId: h.appId,
                formId: h.formId,
                entryId: h.entryId,
              });
              var cddashConfig = Object.fromEntries(
                Object.entries(h.components).filter(([, val]) => {
                  return !val["parentsId"];
                })
              );
              h.components = cddashConfig;

              let theme = "";
              if (h.styles && h.styles.theme && h.styles.theme.name) {
                theme = h.styles.theme.name;
              }
              let rootTokenDashClass =
                "rootTokenDashClass" +
                window.FX.STATIC.APPID +
                menu.reportId +
                "popup" +
                window.FX.STATIC.zIndex++;
              BsySlidePane({
                title: h.name,
                theme: theme,
                onHeaderMenu: () => {
                  return (
                    <div className="slide-dash-menu">
                      {h.showFilter ? (
                        <>
                          <div
                            className="dash-filter-rel"
                            onMouseEnter={(e) => {
                              this.showTooltip(
                                e.currentTarget,
                                rel === "and"
                                  ? React.language("reset.filter.and.tip")
                                  : React.language("reset.filter.or.tip"),
                                "bottom",
                                10
                              );
                            }}
                            onMouseLeave={() => {
                              this.hideTooltip();
                            }}
                            data-place={"bottom"}
                            data-type={window.mode}
                            data-html={true}
                          >
                            <BsySelect
                              allowBlank={false}
                              searchable={false}
                              value={rel}
                              items={[
                                {
                                  value: "and",
                                  text: React.language("filter.rel.and"),
                                },
                                {
                                  value: "or",
                                  text: React.language("filter.rel.or"),
                                },
                              ]}
                              onStopEdit={(val) => {
                                that.onResetRel(val);
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {h.cacheFilter ? (
                        <>
                          <div
                            data-place={"bottom"}
                            data-type={window.mode}
                            data-html={true}
                            className="dash-filter-reset"
                            onClick={that.onResetFilter}
                            onMouseEnter={(e) => {
                              this.showTooltip(
                                e.currentTarget,
                                React.language("reset.filter"),
                                "bottom",
                                10
                              );
                            }}
                            onMouseLeave={() => {
                              this.hideTooltip();
                            }}
                          >
                            <i className={"icon-async"} />
                            <span>{React.language("richtext.reset")}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                },
                onContentCreate: () => {
                  return (
                    <BsyDashContainer
                      {...{
                        ...h,
                        appId: h.appId,
                        entryId: h.entryId,
                        showType: "popup",

                        popupFormPath: that.popupFormPath.concat({
                          appId: widget.appId,
                          formId: widget.forms[0],
                          entryId: widget.entryId,
                          widgetId: widget.widgetId,
                          menuId: menu.menuId,
                          menuType: "datamenu",
                        }),
                      }}
                      allComponentDash={allComponentDash}
                      is_dock_form={f.is_dock_form}
                      // rel={rel}
                      rootTokenDashClass={rootTokenDashClass}
                      getContext={that.getPupupDashContext}
                      prefix={"tablepopu"}
                    />
                  );
                },
                onClose: () => {
                  let d = document.getElementById(rootTokenDashClass);
                  if (d) {
                    d.remove();
                  }
                  switch (menu.refreshMode) {
                    case "all": {
                      that.reload({});
                      break;
                    }

                    case "custom": {
                      that.onRefreshChars(menu.refreshChars);
                      break;
                      // FX.Utils.applyFunc(e, e.options.onRefreshChars, [menu.refreshChars], !1)
                    }
                    default:
                  }
                },
              });
            }
          );

          break;
        }
        default: {
        }
      }
      return;
    }

    let d1 = BsyUtils.checkRefApp({
      appId: widget.appId,
      entryId: widget.entryId,
      formId: widget.forms[0],
      dataId: rowdata._id,
      iseditable: !1,
      fields: widget.fields,
      formulas: widget.formulas,
    });

    // pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
    // widgetId:_options.widgetId,  //控件id
    // dataId:[rowdata._id],  //数据id 不管多选还是单选 都是数组
    // data:rowdata,  //数据id 不管多选还是单选 都是数组
    // header:_this.header,  //数据id 不管多选还是单选 都是数组

    let newHeader = [...widget.fields];
    if (menu.type === "popupreport") {
      for (let i = 0; i < menu.arg.length; i++) {
        let dg = menu.arg[i];
        if (dg.mode === "depend") {
          newHeader.push({
            form: widget.fields[0].form,
            name: dg.depend.field,
            type: dg.type,
            tag: dg.depend.field,
          });
        }
      }
    }

    window.FX.Utils.dataAjax(
      {
        url: "/data/reporttablemenudata",
        data: {
          appId: widget.appId,
          entryId: widget.entryId,
          formId: widget.forms[0],
          header: newHeader,
          widgetId: widget.widgetId,
          dataId: [d1.dataId],
          popupFormPath: that.popupFormPath.concat({
            appId: widget.appId,
            entryId: widget.entryId,
            formId: widget.forms[0],
            widgetId: widget.widgetId,
            AppMobileMenu: widget.AppMobileMenu,
            menuId: menu.menuId,
            menuType: "datamenu",
          }),
        },
      },
      function (g) {
        if (!BsyUtils.isObjectEmpty(g.data)) {
          rowdata = g.data;
        }
        BsyUtils.forEach(widget.fields, (index, data) => {
          if (rowdata.hasOwnProperty(data.tag))
            rowdata[data.name] = rowdata[data.tag];
        });

        // let tmpfields = i.fields.concat(i.formulas);
        // window.FX.Utils.forEach(tmpfields,function(index,dd){
        //     if(g.data.hasOwnProperty(dd.name))
        //     {
        //         rowdata[dd.tag] = g.data[dd.name]
        //     }
        // })
        // rowdata["_id"] = g.data._id;

        switch (menu.type) {
          case "event":
          case "module":
          case "datahelp": {
            if (menu.alert && menu.alertinfo.msg) {
              window.FX.Msg.alert({
                // title: ,
                title: menu.alertinfo.msg,
                type: menu.alertinfo.icon,
                onOk: function () {
                  that.BBY_RowMenuEvent(
                    menuId,
                    menu,
                    rowdata,
                    0,
                    that.rowMenuCallback
                  );
                },
                onCancel: function () { },
              });
            } else {
              that.BBY_RowMenuEvent(
                menuId,
                menu,
                rowdata,
                0,
                that.rowMenuCallback
              );
            }
            break;
          }

          case "popupform": {
            that.BBY_RowMenuEvent(
              menuId,
              menu,
              rowdata,
              0,
              that.rowMenuCallback
            );
            break;
          }
          case "popupreport": {
            window.FX.STATIC.APPID = widget.appId;
            window.FX.Utils.dataAjax(
              {
                url:
                  "/dashboard/app/" +
                  window.FX.STATIC.APPID +
                  "/entry/" +
                  menu.reportId,
                data: {
                  popupFormPath: that.popupFormPath.concat({
                    appId: widget.appId,
                    formId: widget.forms[0],
                    entryId: widget.entryId,
                    widgetId: widget.widgetId,
                  }),
                },
              },
              function (f) {
                let h = f.entry;
                BsyUtils.forEach(h.components, (key, value) => {
                  if (BsyUtils.isObjectEmpty(value)) {
                    delete h.components[key];
                  }
                });
                // let rel = h.rel || 'and';
                let rel =
                  (that.context &&
                    that.context.getOverallSituationValue("rel")) ||
                  "and";
                BsyUtils.forEach(that.filterMap, function (a1, b1) {
                  rowdata[a1] = b1;
                });
                window.FX.Utils._filterDefaultReplace(h, menu, rowdata);
                const allComponentDash = _.cloneDeep({
                  ...f,
                  appId: h.appId,
                  formId: h.formId,
                  entryId: h.entryId,
                });
                var cddashConfig = Object.fromEntries(
                  Object.entries(h.components).filter(([, val]) => {
                    return !val["parentsId"];
                  })
                );
                h.components = cddashConfig;

                let theme = "";
                if (h.styles && h.styles.theme && h.styles.theme.name) {
                  theme = h.styles.theme.name;
                }
                let rootTokenDashClass =
                  "rootTokenDashClass" +
                  window.FX.STATIC.APPID +
                  menu.reportId +
                  "popup" +
                  window.FX.STATIC.zIndex++;
                BsySlidePane({
                  title: h.name,
                  theme: theme,
                  onHeaderMenu: () => {
                    return (
                      <div className="slide-dash-menu">
                        {h.showFilter ? (
                          <>
                            <div
                              className="dash-filter-rel"
                              onMouseEnter={(e) => {
                                this.showTooltip(
                                  e.currentTarget,
                                  rel === "and"
                                    ? React.language("reset.filter.and.tip")
                                    : React.language("reset.filter.or.tip"),
                                  "bottom",
                                  10
                                );
                              }}
                              onMouseLeave={() => {
                                this.hideTooltip();
                              }}
                              data-place={"bottom"}
                              data-type={window.mode}
                              data-html={true}
                            >
                              <BsySelect
                                allowBlank={false}
                                searchable={false}
                                value={rel}
                                items={[
                                  {
                                    value: "and",
                                    text: React.language("filter.rel.and"),
                                  },
                                  {
                                    value: "or",
                                    text: React.language("filter.rel.or"),
                                  },
                                ]}
                                onStopEdit={(val) => {
                                  that.onResetRel(val);
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {h.cacheFilter ? (
                          <>
                            <div
                              onMouseEnter={(e) => {
                                this.showTooltip(
                                  e.currentTarget,
                                  React.language("reset.filter"),
                                  "bottom",
                                  10
                                );
                              }}
                              onMouseLeave={() => {
                                this.hideTooltip();
                              }}
                              data-place={"bottom"}
                              data-type={window.mode}
                              data-html={true}
                              className="dash-filter-reset"
                              onClick={that.onResetFilter}
                            >
                              <i className={"icon-async"} />
                              <span>{React.language("richtext.reset")}</span>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  },
                  onContentCreate: () => {
                    return (
                      <BsyDashContainer
                        {...{
                          ...h,
                          appId: h.appId,
                          entryId: h.entryId,
                          showType: "popup",
                          popupFormPath: that.popupFormPath.concat({
                            appId: widget.appId,
                            formId: widget.forms[0],
                            entryId: widget.entryId,
                            widgetId: widget.widgetId,
                            menuId: menu.menuId,
                            menuType: "datamenu",
                          }),
                        }}
                        allComponentDash={allComponentDash}
                        is_dock_form={f.is_dock_form}
                        // rel={rel}
                        rootTokenDashClass={rootTokenDashClass}
                        getContext={that.getPupupDashContext}
                        prefix={"tablepopu"}
                      />
                    );
                  },
                  onClose: () => {
                    let d = document.getElementById(rootTokenDashClass);
                    if (d) {
                      d.remove();
                    }
                    switch (menu.refreshMode) {
                      case "all": {
                        that.reload({});
                        break;
                      }

                      case "custom": {
                        that.onRefreshChars(menu.refreshChars);
                        break;
                        // FX.Utils.applyFunc(e, e.options.onRefreshChars, [menu.refreshChars], !1)
                      }
                      default:
                    }
                  },
                });
              }
            );

            break;
          }

          default: {
          }
        }
      }
    );
  };

  BBY_RowMenuEvent = (menuId, menu, rowdata, action, cb) => {
    const { widget } = this.state;
    let _this = this;
    let _options = widget;
    if (!_this.menuStatus) {
      _this.menuStatus = {};
    }
    if (_this.menuStatus[menuId]) {
      return;
    }
    let extendSet = menu.extendSet;
    if (BsyUtils.isObjectEmpty(extendSet)) {
      extendSet = {};
      extendSet.funMode = menu.type;
      extendSet.libs = menu.libs;
      extendSet.module = menu.module;
    } else {
      extendSet.funMode = menu.type;
    }

    let t1 = null;
    switch (extendSet.funMode) {
      case "event":
      case "module":
      case "datahelp": {
        if (BsyUtils.isObjectEmpty(extendSet.module)) {
          extendSet.funMode = menu.type;
          extendSet.libs = menu.libs;
          extendSet.module = menu.module;
        }

        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });
        break;
      }

      case "popupform":
      case "popupreport":
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });
        break;
      default: {
      }
    }
    _this.menuStatus[menuId] = !0;

    React.axios("/data/reporttablemenu", {
      appId: _options.appId,
      entryId: _options.entryId,
      formId: _options.forms[0], //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
      pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
      widgetId: _options.widgetId, //控件id
      dataId: [rowdata._id], //数据id 不管多选还是单选 都是数组
      data: rowdata, //数据id 不管多选还是单选 都是数组
      header: _options.fields, //数据id 不管多选还是单选 都是数组

      // filter: this.componentContext.getFilterData(), //筛选条件的值,
      filter: this.context && this.context.getOverallSituationValue("filter"), //筛选条件的值,

      menuId: menu.menuId, //菜单id,
      arg: menu.arg, //菜单id,
      datahelpids: extendSet.datahelpids, //数据助手id,
      libs: extendSet.libs, //功能操作相关的参数,
      value: menu.value, //功能操作相关的参数,
      type: extendSet.funMode || menu.type, //菜单id,
      action: action, //菜单类型 0单条 1批量
      batch: menu.selectAll, //是否全选 1全选 0无全选 批量的情况才有可能全选
      popupFormPath: _this.popupFormPath.concat({
        appId: _options.appId,
        entryId: _options.entryId,
        formId: _options.forms[0],
        widgetId: _options.widgetId,
        AppMobileMenu: _options.AppMobileMenu,
        menuId: menu.menuId,
        menuType: "datamenu",
      }),
    })
      .then((res) => {
        const t = res.data;
        t.dataId = rowdata._id;
        cb && cb(t, menu);
        _this.menuStatus[menuId] = !1;
        if (t1) {
          t1.close();
          t1 = null;
        }
      })
      .catch((err) => {
        _this.menuStatus[menuId] = !1;
        if (t1) {
          t1.close();
          t1 = null;
        }
      });

    // window.FX.Utils.dataAjax(
    //   {
    //     url: "/data/reporttablemenu",
    //     data:
    //      {
    //       appId: _options.appId,
    //       entryId: _options.entryId,
    //       formId: _options.forms[0], //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
    //       pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
    //       widgetId: _options.widgetId, //控件id
    //       dataId: [rowdata._id], //数据id 不管多选还是单选 都是数组
    //       data: rowdata, //数据id 不管多选还是单选 都是数组
    //       header: _options.fields, //数据id 不管多选还是单选 都是数组

    //       // filter: this.componentContext.getFilterData(), //筛选条件的值,
    //       filter: this.context && this.context.getOverallSituationValue("filter"), //筛选条件的值,

    //       menuId: menu.menuId, //菜单id,
    //       arg: menu.arg, //菜单id,
    //       datahelpids: extendSet.datahelpids, //数据助手id,
    //       libs: extendSet.libs, //功能操作相关的参数,
    //       value: menu.value, //功能操作相关的参数,
    //       type: extendSet.funMode || menu.type, //菜单id,
    //       action: action, //菜单类型 0单条 1批量
    //       batch: menu.selectAll, //是否全选 1全选 0无全选 批量的情况才有可能全选
    //       popupFormPath: _this.popupFormPath.concat({
    //         appId: _options.appId,
    //         entryId: _options.entryId,
    //         formId: _options.forms[0],
    //         widgetId: _options.widgetId,
    //         AppMobileMenu: _options.AppMobileMenu,
    //         menuId: menu.menuId,
    //         menuType: "datamenu",
    //       }),
    //     },
    //   },
    //   function (t) {
    //     t.dataId = rowdata._id;
    //     cb && cb(t, menu);
    //     _this.menuStatus[menuId] = !1;
    //     if (t1) {
    //       t1.close();
    //       t1 = null;
    //     }
    //   },
    //   function (t) {
    //     _this.menuStatus[menuId] = !1;
    //     let c = JSON.parse(t.responseText) || {};
    //     cb && cb(c, menu);
    //     if (t1) {
    //       t1.close();
    //       t1 = null;
    //     }
    //   },
    //   function () {
    //     _this.menuStatus[menuId] = !1;
    //     if (t1) {
    //       t1.close();
    //       t1 = null;
    //     }
    //   }
    // );
  };

  rowMenuCallback = (h, menu) => {
    let that = this;

    if (!h && !menu) {
      return;
    }

    switch (menu.type) {
      case "popupform": {
        if (h.code === 400) {
          return tipAlert({
            type: "error",
            msg: h.msg,
          });
        }
        h.entry.content.eventType = menu.type;
        h.entry.theme = null;
        this.componentContext.create({ data: h }, menu, function () {
          tip();
        });

        break;
      }
      default: {
        let type = "";
        if (h.code === 200) {
          type = "success";
        } else if (h.msg) {
          type = "warning";
        }
        tipAlert({
          type: type,
          msg: h.msg,
        });
        tip();
      }
    }

    function tip() {
      switch (menu.refreshMode) {
        case "all": {
          switch (menu.type) {
            case "popupform": {
              if (that.componentContext.isSubmitData) {
                that.reload();
                return;
              }

              if (
                h &&
                h.entry &&
                h.entry.content &&
                h.entry.content.isSubmit === "no"
              ) {
                that.reload();
              }
              break;
            }
            default: {
              that.reload();
            }
          }

          break;
        }

        case "custom": {
          switch (menu.type) {
            case "popupform": {
              if (that.componentContext.isSubmitData) {
                if (that.props.onRefreshChars) {
                  that.props.onRefreshChars(menu.refreshChars);
                }
                return;
              }
              if (that.props.onRefreshChars) {
                if (
                  h &&
                  h.entry &&
                  h.entry.content &&
                  h.entry.content.isSubmit === "no"
                )
                  that.props.onRefreshChars(menu.refreshChars);
              }
              break;
            }
            default: {
              if (that.props.onRefreshChars)
                that.props.onRefreshChars(menu.refreshChars);
            }
          }

          break;
        }

        default: {
          //啥也不干
        }
      }
    }
  };

  //---- 统一报表 单行数据的处理逻辑 ----

  _menuBatchEvnet = (
    menuId,
    batch,
    datas,
    header,
    data,
    metricmenuSwitch,
    metricmenu,
    action,
    menuType
  ) => {
    const { widget } = this.state;
    const { mode } = this.state;
    if (mode === "preview") {
      return;
    }
    let _this = this;
    let menu = _this.batchmenuMap[menuId] || metricmenu;
    let action1 = 1;
    if (action) {
      action1 = 0;
    }
    if (metricmenuSwitch && metricmenu) {
      menu = metricmenu;
    }

    data = data || [];
    datas = datas || [];
    header = header || [];
    if (BsyUtils.isArray(data)) {
      BsyUtils.forEach(data, function (obj, val) {
        for (let i = 0; i < header.length; i++) {
          let dt = header[i];
          if (!val[dt.name]) val[dt.name] = val[dt.tag];
        }

        if (widget && widget.cardConfigFields) {
          for (let i = 0; i < widget.cardConfigFields.length; i++) {
            let dt = widget.cardConfigFields[i];
            if (!val[dt.name]) val[dt.name] = val[dt.tag];
          }
        }
      });
    } else {
      for (let i = 0; i < header.length; i++) {
        let dt = header[i];
        if (!data[dt.name]) data[dt.name] = data[dt.tag];
      }

      if (widget && widget.cardConfigFields) {
        for (let i = 0; i < widget.cardConfigFields.length; i++) {
          let dt = widget.cardConfigFields[i];
          if (!data[dt.name]) data[dt.name] = data[dt.tag];
        }
      }
    }

    switch (menu.type) {
      case "module":
      case "event":
      case "datahelp": {
        function cb0(h) {
          let type = "";
          if (h.code === 200) {
            type = "success";
            _this.customizeExitMenuOperate();
          } else if (h.msg) {
            type = "warning";
          }
          tipAlert({
            type: type,
            msg: h.msg,
          });
          switch (menu.refreshMode) {
            case "all": {
              _this.reload({});
              break;
            }

            case "custom": {
              _this.onRefreshChars(menu.refreshChars);
              break;
            }

            default: {
            }
          }
        }
        if (menu.alert && menu.alertinfo.msg) {
          window.FX.Msg.alert({
            // title: ,
            title: menu.alertinfo.msg,
            type: menu.alertinfo.icon,
            onOk: function () {
              _this.BBY_menuEvent(
                menuId,
                menu,
                datas,
                action1,
                batch,
                cb0,
                header,
                data,
                metricmenuSwitch,
                metricmenu,
                menuType
              );
            },
            onCancel: function () { },
          });
        } else {
          _this.BBY_menuEvent(
            menuId,
            menu,
            datas,
            action1,
            batch,
            cb0,
            header,
            data,
            metricmenuSwitch,
            metricmenu,
            menuType
          );
        }
        break;
      }
      case "popupform": {
        function cb1(t) {
          if (t.hasOwnProperty("code")) {
            return tipAlert({
              type: "error",
              msg: t.msg,
            });
          }
          t.entry.theme = null;
          _this.creatForm(
            { data: t, eventType: menu.type },
            menu.refreshMode === "all",
            function () {
              if (menu.refreshMode === "all") {
                if (_this.isSubmitData) {
                  _this.reload({});
                  return;
                }
                if (
                  t &&
                  t.entry &&
                  t.entry.content &&
                  t.entry.content.isSubmit === "no"
                ) {
                  _this.reload({});
                }
              } else if (menu.refreshMode === "custom") {
                if (_this.isSubmitData) {
                  _this.onRefreshChars(menu.refreshChars);
                  return;
                }
                if (t && !t.entry) {
                  _this.onRefreshChars(menu.refreshChars);
                  return;
                }
                if (
                  t &&
                  t.entry &&
                  t.entry.content &&
                  t.entry.content.isSubmit === "no"
                )
                  _this.onRefreshChars(menu.refreshChars);
              }
            },
            menuId,
            metricmenuSwitch,
            metricmenu,
            menuType,
            data
          );
          _this.customizeExitMenuOperate();
        }
        _this.BBY_menuEvent(
          menuId,
          menu,
          datas,
          action1,
          batch,
          cb1,
          header,
          data,
          metricmenuSwitch,
          metricmenu
        );
        break;
      }
      case "popupreport": {
        window.FX.STATIC.APPID = _this.state.widget.appId;
        window.FX.Utils.dataAjax(
          {
            url:
              "/dashboard/app/" +
              window.FX.STATIC.APPID +
              "/entry/" +
              menu.reportId,
            data: {
              popupFormPath: _this.popupFormPath,
            },
          },
          function (f) {
            let h = f.entry;
            BsyUtils.forEach(h.components, (key, value) => {
              if (BsyUtils.isObjectEmpty(value)) {
                delete h.components[key];
              }
            });
            // let rel = h.rel || 'and';
            let rel =
              (_this.context &&
                _this.context.getOverallSituationValue("rel")) ||
              "and";
            let rowdata = data;
            BsyUtils.forEach(_this.filterMap, function (a1, b1) {
              rowdata[a1] = b1;
            });
            window.FX.Utils._filterDefaultReplace(h, menu, rowdata);
            const allComponentDash = _.cloneDeep({
              ...f,
              appId: h.appId,
              formId: h.formId,
              entryId: h.entryId,
            });
            var cddashConfig = Object.fromEntries(
              Object.entries(h.components).filter(([, val]) => {
                return !val["parentsId"];
              })
            );
            h.components = cddashConfig;

            let theme = "";
            if (h.styles && h.styles.theme && h.styles.theme.name) {
              theme = h.styles.theme.name;
            }
            let rootTokenDashClass =
              "rootTokenDashClass" +
              window.FX.STATIC.APPID +
              menu.reportId +
              "popup" +
              window.FX.STATIC.zIndex++;
            BsySlidePane({
              title: h.name,
              theme: theme,
              onHeaderMenu: () => {
                return (
                  <div className="slide-dash-menu">
                    {h.showFilter ? (
                      <>
                        <div
                          className="dash-filter-rel"
                          onMouseEnter={(e) => {
                            this.showTooltip(
                              e.currentTarget,
                              rel === "and"
                                ? React.language("reset.filter.and.tip")
                                : React.language("reset.filter.or.tip"),
                              "bottom",
                              10
                            );
                          }}
                          onMouseLeave={() => {
                            this.hideTooltip();
                          }}
                          data-place={"bottom"}
                          data-type={window.mode}
                          data-html={true}
                        >
                          <BsySelect
                            allowBlank={false}
                            searchable={false}
                            value={rel}
                            theme={theme}
                            items={[
                              {
                                value: "and",
                                text: React.language("filter.rel.and"),
                              },
                              {
                                value: "or",
                                text: React.language("filter.rel.or"),
                              },
                            ]}
                            onStopEdit={(val) => {
                              _this.onResetRel(val);
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {h.cacheFilter ? (
                      <>
                        <div
                          onMouseEnter={(e) => {
                            this.showTooltip(
                              e.currentTarget,
                              React.language("reset.filter"),
                              "bottom",
                              10
                            );
                          }}
                          onMouseLeave={() => {
                            this.hideTooltip();
                          }}
                          data-place={"bottom"}
                          data-type={window.mode}
                          data-html={true}
                          className="dash-filter-reset"
                          onClick={_this.onResetFilter}
                        >
                          <i className={"icon-async"} />
                          <span>{React.language("richtext.reset")}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                );
              },
              onContentCreate: () => {
                return (
                  <BsyDashContainer
                    {...{
                      ...h,
                      appId: h.appId,
                      entryId: h.entryId,
                      showType: "popup",
                      popupFormPath: _this.popupFormPath.concat({
                        appId: widget.appId,
                        formId: widget.forms[0],
                        entryId: widget.entryId,
                        widgetId: widget.widgetId,
                        // AppMobileMenu: _this.props.AppMobileMenu,
                        menuId: menu.menuId,
                        menuType: menuType
                          ? menuType
                          : widget.metricmenuSwitch && widget.metricmenu
                            ? "metric"
                            : widget.metricmenu
                              ? "datamenu"
                              : "menu",
                      }),
                    }}
                    allComponentDash={allComponentDash}
                    is_dock_form={f.is_dock_form}
                    rootTokenDashClass={rootTokenDashClass}
                    rel={rel}
                    getContext={_this.getPupupDashContext}
                    prefix={"tablepopu"}
                  />
                );
              },
              onClose: () => {
                let d = document.getElementById(rootTokenDashClass);
                if (d) {
                  d.remove();
                }
                switch (menu.refreshMode) {
                  case "all": {
                    _this.reload({});
                    break;
                  }

                  case "custom": {
                    _this.onRefreshChars(menu.refreshChars);
                    break;
                    // FX.Utils.applyFunc(e, e.options.onRefreshChars, [menu.refreshChars], !1)
                  }
                  default:
                }
              },
            });
          }
        );
        break;
      }
      default: {
      }
    }
  };

  creatForm = (res, isreload, cb, menuId, metricmenuSwitch, metricmenu) => {
    const { mode } = this.state;
    if (mode === "preview") {
      return;
    }

    let that = this;
    let n = this.props.widget;
    that.isSubmitData = false;
    const h = res ? res.data.entry : {};

    that.appId = window.FX.STATIC.appId || window.FX.STATIC.APPID;
    that.entryId = window.FX.STATIC.entryId || window.FX.STATIC.entryId;
    window.FX.STATIC.appId = window.FX.STATIC.APPID = h.appId;
    window.FX.STATIC.entryId = window.FX.STATIC.ENTRYID = h.entryId;
    window.FX.STATIC.INNERLINK = h._id;
    that.popupFormPath = that.popupFormPath || [];
    if (!BsyUtils.isObjectEmpty(h.href)) {
      window.FX.STATIC.FORMHREF = h.href;
    } else {
      window.FX.STATIC.FORMHREF = null;
    }

    let formConfig = {
      ...h,
      appId: h.appId,
      entryId: h.entryId,
    };
    formConfig.content.width = 1080;
    formConfig.content.name = h.name;
    formConfig.content.eventType = res.eventType;

    that.isSubmitData = false;
    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            hasHeader={true}
            {...{
              popupFormPath: that.popupFormPath.concat({
                appId: n.appId,
                entryId: n.entryId,
                formId: n.forms[0],
                widgetId: n.widgetId,
                menuId: menuId,
                menuType:
                  metricmenuSwitch && metricmenu
                    ? "metric"
                    : metricmenu
                      ? "datamenu"
                      : "menu",
              }),
            }}
            formConfig={formConfig}
            mode={"new"}
            onClose={(status) => {
              window.FX.STATIC.appId = window.FX.STATIC.APPID = that.appId;
              window.FX.STATIC.entryId = window.FX.STATIC.ENTRYID =
                that.entryId;
              that.isSubmitData = status;

              if (status && isreload) {
                if (!cb) that.reload({});
              }
              cb && cb();
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  BBY_reportCreatForm = (
    g,
    isreload,
    eventType,
    cb,
    menuId,
    metricmenuSwitch,
    metricmenu,
    menuType,
    data
  ) => {
    eventType = eventType || "popupform";
    this.isSubmitData = false;
    let n = this.props.widget,
      e = this,
      f = window
        .$('<div class="x-window-mask modal light"/>')
        .css({
          "z-index": window.FX.STATIC.zIndex++,
        })
        .appendTo("body");
    window.FX.STATIC.IS_EVENT = g.entry.isEvent === true;
    let hasFooter = true;
    if (g.entry.content.isSubmit !== "no") hasFooter = true;
    else hasFooter = false;

    window.FX.STATIC.APPID = g.entry.appId;
    window.FX.STATIC.ENTRYID = g.entry.entryId;
    let formview = new window.FX.Form(
      window.$.extend(g.entry.content, {
        renderEl: window.$("<div class='x-shadow-content'/>").appendTo(f),
        appId: g.entry.appId,
        entryId: g.entry.entryId,
        enableRowEdit: g.entry.enableRowEdit,
        hasFlow: !g.entry.hasCoop && g.entry.hasFlow,
        multiTabs: g.entry.formTabs,
        designDataId: data ? data._id : "",
        hasFlowPrint: g.entry.hasFlowPrint,
        flows: g.entry.flow,
        is_dock_form: g.is_dock_form,
        isEvent: g.entry.isEvent,
        height: "100%",
        width: 1080,
        submitText: React.language("submit"),
        eventType: eventType,
        hasFooter: hasFooter,
        printText: g.entry.hasFlowPrint ? g.entry.flow.print_text : null,
        // buttonPosition: "middle",
        customCls: "more-btn fui_platform",
        submitUrl: "/data/create",
        title: g.entry.name,
        popupFormPath: e.popupFormPath.concat({
          appId: n.appId,
          entryId: n.entryId,
          formId: n.forms[0],
          widgetId: n.widgetId,
          menuId: menuId,
          menuType:
            metricmenuSwitch && metricmenu
              ? "metric"
              : metricmenu
                ? "datamenu"
                : "menu",
        }),
        onSuccess: function (a, flowAction, needPrint) {
          if (a.error_code) {
            let title = React.language("form.submit.fail.charger");
            let msg = React.language("form.submit.fail.charger.desc");
            if (
              a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND
            ) {
              title = React.language("form.submit.fail.cond");
              msg = React.language("form.submit.fail.cond.desc");
            }
            window.FX.Msg.alert({
              title: title,
              msg: msg,
              type: "warning",
              text4Cancel: null,
              text4Ok: React.language("iSee"),
            });
            return;
          }
          e.isSubmitData = true;
          formview.element.find(".widget-wrapper").empty();
          formview.element.find(".footer").remove();
          if (needPrint) {
            window.FX.Utils._showFormPrint(a.data);
            window.FX.Utils.showSuccessInfo(
              formview.element.find(".widget-wrapper"),
              a,
              function () {
                f.remove();
                e.BBY_reportCreatForm(
                  g,
                  isreload,
                  null,
                  null,
                  menuId,
                  metricmenuSwitch,
                  metricmenu
                );
              }
            );
          } else {
            if (a.submitPrompt.popupAutoClose) {
              window.FX.STATIC.APPID = n.appId;
              window.FX.STATIC.ENTRYID = n.entryId;
              f.remove();

              cb && cb();
              return;
            }
            window.FX.Utils.showSuccessInfo(
              formview.element.find(".widget-wrapper"),
              a,
              function () {
                f.remove();
                e.BBY_reportCreatForm(
                  g,
                  isreload,
                  null,
                  null,
                  menuId,
                  metricmenuSwitch,
                  metricmenu
                );
              }
            );
          }

          // needPrint && FX.Utils._showFormPrint(a.data)
        },
        onError: function (a) {
          formview.element.find(".widget-wrapper").empty();
          formview.element.find(".footer").remove();
          window.FX.Utils.showErrorInfo(
            formview.element.find(".widget-wrapper"),
            a,
            function () {
              f.remove();
              e.BBY_reportCreatForm(
                g,
                isreload,
                null,
                null,
                menuId,
                metricmenuSwitch,
                metricmenu
              );
            }
          );
        },
        onAfterCancel: function () {
          f.remove();
          // isref && isreload && e.dealRefreshSort();
          cb && cb();
          // console.log([n.appId, n.entryId].join("#"));
          window.FX.STATIC.APPID = n.appId;
          window.FX.STATIC.ENTRYID = n.entryId;
        },
      })
    );
  };

  getReporttablemenuFilter() {
    let list = Object.values(this?.context?.getOverallSituationValue("filter"))
    const fiList = list.filter((item) => {
      return item?.triggers?.[0] === this.state.widget.widgetId
    })
    return {
      cond: fiList,
      rel: this?.context?.getOverallSituationValue("rel")
    }

    // {cond:Object.values(_this?.context?.getOverallSituationValue("filter")),rel:_this?.context?.getOverallSituationValue("rel")}
  }

  //菜单触发后端事件
  BBY_menuEvent = (
    menuId,
    menu,
    rowdata,
    action,
    batch,
    cb,
    header,
    data,
    metricmenuSwitch,
    metricmenu,
    menuType
  ) => {
    const { mode } = this.state;
    if (mode === "preview") {
      return;
    }

    let _this = this;
    let _options = this.props.widget;
    let widget = this.state.widget;
    if (!_this.menuStatus) {
      _this.menuStatus = {};
    }
    if (_this.menuStatus[menuId]) {
      return;
    }

    let extendSet = menu.extendSet;
    if (window.FX.Utils.isObjectEmpty(extendSet)) {
      extendSet = {};
      extendSet.funMode = menu.type;
      extendSet.libs = menu.libs;
      extendSet.module = menu.module;
    } else {
      extendSet.funMode = menu.type;
    }

    let t1 = null;
    switch (extendSet.funMode) {
      case "event":
      case "module":
      case "datahelp": {
        if (window.FX.Utils.isObjectEmpty(extendSet.module)) {
          extendSet.funMode = menu.type;
          extendSet.libs = menu.libs;
          extendSet.module = menu.module;
        }
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });

        break;
      }

      case "popupform":
      case "popupreport": {
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });
        break;
      }
      default: {
      }
    }
    _this.menuStatus[menuId] = !0;
    React.axios("/data/reporttablemenu", {
      appId: _options.appId,
      entryId: _options.entryId,
      formId: widget.forms[0], //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
      pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
      widgetId: widget.widgetId, //控件id
      dataId: rowdata, //数据id 不管多选还是单选 都是数组

      // filter: _this.componentContext && _this.componentContext.getFilterData && (_this.componentContext.getFilterData() ? _this.componentContext.getFilterData() : {}),
      filter: this.getReporttablemenuFilter(),
      menuId: menu.menuId, //菜单id,
      arg: menu.arg, //菜单id,
      sort: _this.componentContext && _this.componentContext.state.sort, //菜单id,
      datahelpids: extendSet.datahelpids, //数据助手id,
      libs: extendSet.libs, //功能操作相关的参数,
      type: extendSet.funMode || menu.type, //菜单id,
      header: header, //功能操作相关的参数,
      data: data, //功能操作相关的参数,
      value: menu.value, //功能操作相关的参数,
      action: action, //菜单类型 0单条 1批量
      batch: batch, //是否全选 1全选 0无全选 批量的情况才有可能全选
      popupFormPath: _this.popupFormPath.concat({
        appId: _this.props.appId || _options.appId,
        entryId: _this.props.entryId || _options.entryId,
        formId: _this.props.widget.forms[0],
        widgetId: _this.props.widget.widgetId,
        menuId: menu.menuId,
        menuType: menuType
          ? menuType
          : metricmenuSwitch && metricmenu
            ? "metric"
            : metricmenu
              ? "datamenu"
              : "menu",
      }),
    })
      .then((res) => {
        const t = res.data;
        cb && cb(t);
        _this.menuStatus[menuId] = !1;
        t1 && t1.close();
      })
      .catch((err) => {
        _this.menuStatus[menuId] = !1;
        if (t1) {
          t1.close();
          t1 = null;
        }
      });

    // window.FX.Utils.dataAjax(
    //   {
    //     url: "/data/reporttablemenu",
    //     data: {
    //       appId: _options.appId,
    //       entryId: _options.entryId,
    //       formId: widget.forms[0], //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
    //       pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
    //       widgetId: widget.widgetId, //控件id
    //       dataId: rowdata, //数据id 不管多选还是单选 都是数组

    //       // filter: _this.componentContext && _this.componentContext.getFilterData && (_this.componentContext.getFilterData() ? _this.componentContext.getFilterData() : {}),
    //       filter: _this.context && _this.context.getOverallSituationValue("filter"),
    //       menuId: menu.menuId, //菜单id,
    //       arg: menu.arg, //菜单id,
    //       sort: _this.componentContext && _this.componentContext.state.sort, //菜单id,
    //       datahelpids: extendSet.datahelpids, //数据助手id,
    //       libs: extendSet.libs, //功能操作相关的参数,
    //       type: extendSet.funMode || menu.type, //菜单id,
    //       header: header, //功能操作相关的参数,
    //       data: data, //功能操作相关的参数,
    //       value: menu.value, //功能操作相关的参数,
    //       action: action, //菜单类型 0单条 1批量
    //       batch: batch, //是否全选 1全选 0无全选 批量的情况才有可能全选
    //       popupFormPath: _this.popupFormPath.concat({
    //         appId: _this.props.appId || _options.appId,
    //         entryId: _this.props.entryId || _options.entryId,
    //         formId: _this.props.widget.forms[0],
    //         widgetId: _this.props.widget.widgetId,
    //         menuId: menu.menuId,
    //         menuType: menuType
    //           ? menuType
    //           : metricmenuSwitch && metricmenu
    //             ? "metric"
    //             : metricmenu
    //               ? "datamenu"
    //               : "menu",
    //       }),
    //     },
    //   },
    //   function (t) {
    //     cb && cb(t);
    //     _this.menuStatus[menuId] = !1;
    //     t1 && t1.close();
    //   },
    //   function (t) {
    //     _this.menuStatus[menuId] = !1;
    //     let c = JSON.parse(t.responseText) || {};
    //     cb && cb(c);
    //     t1 && t1.close();
    //   },
    //   function () {
    //     _this.menuStatus[menuId] = !1;
    //     t1 && t1.close();
    //   }
    // );
  };
}
BsyDashComponent.contextType = WindowPropsContext;
export default BsyDashComponent;

//工作台 配置表单被删除后的结果
export class BsyDashComponentInvalid extends Component {
  static defaultProps = {
    popupFormPath: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      block: props.block,
      operates: props.operates,
    };

    this.element = React.createRef();
    this.etlBtn = React.createRef();
    this.popupFormPath = [...props.popupFormPath];

    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  }

  componentWillUnmount() {
    this.hideTooltip();
  }

  renderTitle = () => {
    const { block } = this.state;
    return (
      <div className="block-title" title={block.name} key={block.widget}>
        {block.name}
      </div>
    );
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  renderBlockContent = () => {
    const { block } = this.state;

    return <div className="invalid-Block"> {block.msg} </div>;
  };

  renderOperateBtns = () => {
    const { operates, mode } = this.state;
    let data = operates[0];
    return (
      <div className="block-operate">
        {mode === "edit" ? (
          <div
            key={data}
            onMouseEnter={(e) => {
              this.showTooltip(
                e.currentTarget,
                React.language(data),
                "bottom",
                10
              );
            }}
            onMouseLeave={() => {
              this.hideTooltip();
            }}
            data-place={"bottom"}
            data-type={window.mode}
            data-html={true}
            className="operate-btn"
            onMouseDown={(e) => {
              // console.log('onMouseUp onDelComponent')
              e.stopPropagation();
              e.preventDefault();
              this.props.onDelComponent && this.props.onDelComponent(e);
            }}
          >
            <i className="icon-trasho"></i>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  render() {
    const { block } = this.state;
    // console.log('ggg BsyDashComponent-' + block.widgetId);
    return (
      <div ref={this.element} className={"bsy_dash_block"}>
        <div className={"block-head "}>
          {this.renderTitle()}
          {this.renderOperateBtns()}
        </div>
        <div
          className={"block-content bsy-" + block.type}
          ref={this.blockContent}
        >
          {this.renderBlockContent()}
        </div>
      </div>
    );
  }
}

export class BsyDashComponentEmpty extends Component {
  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
  }

  loadWidget = (n, d) => {
    this.props.onLoadFail(n, d);
  };

  render() {
    const { type, configErrorTip } = this.props;
    return (
      <div className="block-empty-wrapper">
        <div>
          <i className={BsyUtils._getWidgetTypeIcon(type)}></i>
          <div className="empty-text">
            {BsyUtils._getWidgetTypeName(type) +
              (configErrorTip
                ? React.language("configur.invalid")
                : React.language("not.configured"))}
          </div>
          {configErrorTip && (
            <div
              className="empty-text"
              dangerouslySetInnerHTML={{ __html: configErrorTip }}
            ></div>
          )}
        </div>
      </div>
    );
  }
}
